// Fetch and validate cart limits (or return cart data)
function checkCartLimits(qty = null, itemCartKey = null) {
  return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      let errorMessage = "";
      if (qty !== null) {
        if (cart.item_count >= 25) {
          errorMessage = "Cart limit reached! You can add up to 25 items only.";
        } else if (parseInt(qty, 10) > 5) {
          errorMessage = "Limit reached! You can add up to 5 units only.";
        }
      }

      if (itemCartKey) {
        const cartItem = cart.items.find(item => item.id == itemCartKey);
        if (!cartItem) {
          console.log(`Item with key ${itemCartKey} not found in cart.`);
          return false;
        }

        const errorWrappers = document.querySelectorAll(`.product-error-wrapper[data-variant-id="${cartItem.variant_id}"]`);
        if (errorWrappers.length > 0) {
          errorWrappers.forEach(errorWrapper => {
            const errorMsgField = errorWrapper.querySelector('.product-error-message');
            if (errorMsgField) {
              if (errorMessage) {
                errorMsgField.innerHTML = errorMessage;
                errorWrapper.style.display = 'flex';
                setTimeout(() => {
                  errorWrapper.style.display = 'none';
                  errorMsgField.innerHTML = '';
                }, 2000);
              } else {
                errorWrapper.style.display = 'none';
              }
            }
          });
          return false;
        }


      }

      return cart;
    })
    .catch(error => {
      console.error("Error fetching cart data:", error);
      return false;
    });
}
// Home Reviews & Animation
document.addEventListener("DOMContentLoaded", () => {
  const headerWrapper = document.querySelector('.header__wrapper');
  if (headerWrapper) {
    const headerObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          document.body.classList.toggle('sticky-header', headerWrapper.classList.contains('js__header__stuck'));
        }
      });
    });
    headerObserver.observe(headerWrapper, { attributes: true });
  }

  // Mobile filter drawer
  const mobileFilterButton = document.getElementById('open-mobile-filterDrawer');
  const hiddenFilterNav = document.querySelector('nav.collection__nav.collection__nav--filter');
  const menuDrawer = document.querySelector(".collection__sidebar__slider");
  if (mobileFilterButton && hiddenFilterNav) {
    const filterTriggerButton = hiddenFilterNav.querySelector('button');
    mobileFilterButton.addEventListener("click", () => {
      menuDrawer.classList.add("expanded");
      menuDrawer.classList.add("drawer--animated");
      hiddenFilterNav.style.opacity = "1";
      hiddenFilterNav.style.pointerEvents = "auto";
      console.log("open");
      // if (filterTriggerButton) filterTriggerButton.click();
    });
  }

  // Add-to-cart button click handler
  // Set first size active by default (per product card)
  document.querySelectorAll(".product-card-sizes").forEach(wrapper => {
    const firstSize = wrapper.querySelector(".size-swatch");
    if (firstSize) {
      firstSize.classList.add("active");
    }
  });

  // document.addEventListener("click", function (e) {
  //   const sizeButton = e.target.closest(".size-swatch");
  //   if (!sizeButton) return;

  //   const sizeWrapper = sizeButton.closest(".product-card-sizes");
  //   const productItem = sizeButton.closest(".product-item");
  //   if (!sizeWrapper || !productItem) return;

  //    const variantId = sizeButton.getAttribute("data-variant-id");
  //   if (!variantId) return;

  //   // Remove active from all
  //   sizeWrapper.querySelectorAll(".size-swatch").forEach(btn => {
  //     btn.classList.remove("active");
  //   });

  //   sizeButton.classList.add("active");

  //   //image change 
  //     const variantDataEl = productItem.querySelector(".variant-data");
  //   if (!variantDataEl) return;

  //   let variants = [];
  //   try {
  //     variants = JSON.parse(variantDataEl.textContent);
  //   } catch (e) {
  //     console.error("Invalid variant JSON");
  //     return;
  //   }

  //   const variant = variants.find(v => String(v.id) === String(variantId));
  //   if (!variant) return;


  // productItem
  //   .querySelectorAll('.product-item__bg__inner')
  //   .forEach(img => img.classList.remove('is-active'));

  // const activeImg = productItem.querySelector(
  //   `.product-item__bg__inner[data-variant-id="${variantId}"]`
  // );

  // if (activeImg) {
  //   activeImg.classList.add('is-active');
  // }


  //   //price change

  //   const priceWrapper = productItem.querySelector(".product-tile-price");
  //   if (!priceWrapper) return;

  //   const currencySymbol =
  //     productItem.querySelector(".product-tile-price span")?.innerText?.trim()[0] || "₹";

  //   const price = (variant.price / 100).toFixed(0);
  //   const compareAt = variant.compare_at_price
  //     ? (variant.compare_at_price / 100).toFixed(0)
  //     : null;

  //   if (compareAt && compareAt > price) {
  //     const discount = Math.round(
  //       ((compareAt - price) * 100) / compareAt
  //     );

  //     priceWrapper.innerHTML = `
  //       <span class="product-tile-strikePrice">
  //         <span>${currencySymbol}</span>${compareAt}
  //       </span>
  //       <span class="product-tile-price">
  //         <span>${currencySymbol}</span>${price}
  //       </span>
  //       <span class="product-tile-discount">${discount}% off</span>
  //     `;
  //   } else {
  //     priceWrapper.innerHTML = `
  //       <span class="product-tile-price">
  //         <span>${currencySymbol}</span>${price}
  //       </span>
  //     `;
  //   }


  //   const activeVariantId = sizeButton.getAttribute("data-variant-id");
  //   const atcBtn = productItem.querySelector(".add-to-cart-btn");
  //   const qtyWrapper = productItem.querySelector(".quantity-wrapper");

  //   if (!activeVariantId || !atcBtn || !qtyWrapper) return;

  //   // Update variant id references
  //   atcBtn.setAttribute("data-variant-id", activeVariantId);
  //   qtyWrapper.setAttribute("data-variant-id", activeVariantId);

  //   const minusBtn = qtyWrapper.querySelector('.decrease-cart-qty');
  //   const plusBtn = qtyWrapper.querySelector('.increase-cart-qty');

  //   if (minusBtn) {
  //     minusBtn.dataset.variantId = activeVariantId;
  //     minusBtn.dataset.key = '';
  //   }

  //   if (plusBtn) {
  //     plusBtn.dataset.variantId = activeVariantId;
  //     plusBtn.dataset.key = '';
  //   }


  //   // 🔥 Sync UI with cart
  //   checkCartLimits().then(cart => {
  //     if (!cart || !cart.items) return;

  //     const cartItem = cart.items.find(item => item.id == activeVariantId);

  //     if (cartItem) {
  //       // Variant already in cart → show quantity
  //       atcBtn.classList.add("hide-atc_btn");
  //       qtyWrapper.classList.add("active-qty");

  //       const qtyEl = qtyWrapper.querySelector(".cart-quantity");
  //       if (qtyEl) qtyEl.textContent = cartItem.quantity;

  //       qtyWrapper.setAttribute("data-key", cartItem.key);
  //       qtyWrapper.querySelectorAll("[data-key]").forEach(el => {
  //         el.setAttribute("data-key", cartItem.key);
  //       });
  //     } else {
  //       // Variant NOT in cart → show ATC
  //       atcBtn.classList.remove("hide-atc_btn");
  //       qtyWrapper.classList.remove("active-qty");
  //     }
  //   });
  // });


  function applyVariantUI(sizeButton) {
    if (!sizeButton) return;

    const sizeWrapper = sizeButton.closest(".product-card-sizes");
    const productItem = sizeButton.closest(".product-item");
    if (!sizeWrapper || !productItem) return;

    const variantId = sizeButton.getAttribute("data-variant-id");
    if (!variantId) return;

    // Active state
    sizeWrapper.querySelectorAll(".size-swatch").forEach(btn =>
      btn.classList.remove("active")
    );
    sizeButton.classList.add("active");

    // Variant data
    const variantDataEl = productItem.querySelector(".variant-data");
    if (!variantDataEl) return;

    if (!productItem._variantMap) {
      let variants = [];
      try {
        variants = JSON.parse(variantDataEl.textContent);
      } catch {
        console.error("Invalid variant JSON");
        return;
      }

      productItem._variantMap = {};
      variants.forEach(v => {
        productItem._variantMap[String(v.id)] = v;
      });
    }

    const variant = productItem._variantMap[String(variantId)];
    if (!variant) return;

    /* ---------------- IMAGE ---------------- */
    productItem
      .querySelectorAll(".product-item__bg__inner")
      .forEach(img => img.classList.remove("is-active"));

    const activeImg = productItem.querySelector(
      `.product-item__bg__inner[data-variant-id="${variantId}"]`
    );
    if (activeImg) activeImg.classList.add("is-active");

    /* ---------------- PRICE ---------------- */
    const priceWrapper = productItem.querySelector(".product-tile-price");
    if (!priceWrapper) return;

    const currencySymbol =
      priceWrapper.querySelector("span")?.innerText?.trim()[0] || "₹";

    const price = Math.round(variant.price / 100);
    const compareAt = variant.compare_at_price
      ? Math.round(variant.compare_at_price / 100)
      : null;

    if (compareAt && compareAt > price) {
      const discount = Math.round(
        ((compareAt - price) * 100) / compareAt
      );

      priceWrapper.innerHTML = `
      <span class="product-tile-strikePrice">
        <span>${currencySymbol}</span>${compareAt}
      </span>
      <span class="product-tile-price">
        <span>${currencySymbol}</span>${price}
      </span>
      <span class="product-tile-discount">${discount}% off</span>
    `;
    } else {
      priceWrapper.innerHTML = `
      <span class="product-tile-price">
        <span>${currencySymbol}</span>${price}
      </span>
    `;
    }

    /* ---------------- ATC / QTY ---------------- */
    const atcBtn = productItem.querySelector(".add-to-cart-btn");
    const qtyWrapper = productItem.querySelector(".quantity-wrapper");
    if (!atcBtn || !qtyWrapper) return;

    atcBtn.dataset.variantId = variantId;
    qtyWrapper.dataset.variantId = variantId;

    checkCartLimits().then(cart => {
      if (!cart || !cart.items) return;

      const cartItem = cart.items.find(item => item.id == variantId);

      if (cartItem) {
        atcBtn.classList.add("hide-atc_btn");
        qtyWrapper.classList.add("active-qty");

        const qtyEl = qtyWrapper.querySelector(".cart-quantity");
        if (qtyEl) qtyEl.textContent = cartItem.quantity;

        qtyWrapper.dataset.key = cartItem.key;
      } else {
        atcBtn.classList.remove("hide-atc_btn");
        qtyWrapper.classList.remove("active-qty");
      }
    });
  }

  document.addEventListener("click", function (e) {
    const sizeButton = e.target.closest(".size-swatch");
    if (!sizeButton) return;

    applyVariantUI(sizeButton);
  });

  window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".product-item").forEach(productItem => {
      const activeBtn = productItem.querySelector(".size-swatch.active");
      if (activeBtn) {
        applyVariantUI(activeBtn);
      }
    });
  });


  // document.querySelectorAll('.add-to-cart-btn').forEach(button => {
  // button.addEventListener('click', e => {
  //   e.preventDefault();

  //   const productCard = button.closest('.product-item');
  //   if (!productCard) return;

  //   // 🔥 Get active size variant
  //   const activeSize = productCard.querySelector('.size-swatch.active');

  //   if (!activeSize) {
  //     console.warn('Please select a size');
  //     return;
  //   }

  //   const variantId = activeSize.getAttribute('data-variant-id');
  //   const productId = button.getAttribute('data-product-id');
  //   const qty = button.getAttribute('data-quantity') || '1';

  //   checkCartLimits(qty).then(cart => {
  //     if (!cart) return;

  //     const formData = new FormData();
  //     formData.append('id', variantId);
  //     formData.append('form_type', 'product');
  //     formData.append('utf8', '✓');
  //     formData.append('quantity', qty);
  //     if (productId) formData.append('product-id', productId);
  //     formData.append('section-id', 'template--17632417120300__main');

  //     const addToCartEvent = new CustomEvent('theme:cart:add', {
  //       detail: { button, formData },
  //       bubbles: false
  //     });

  //     document.dispatchEvent(addToCartEvent);
  //   });
  // });
  // });

  //   document.querySelectorAll('.add-to-cart-btn').forEach(button => {
  //   button.addEventListener('click', e => {
  //     e.preventDefault();

  //     const productCard = button.closest('.product-item');
  //     if (!productCard) return;

  //     const sizeWrapper = productCard.querySelector('.product-card-sizes');
  //     let variantId = null;

  //     // 🧠 Case 1: Product HAS size variants
  //     if (sizeWrapper) {
  //       const activeSize = sizeWrapper.querySelector('.size-swatch.active');

  //       if (!activeSize) {
  //         console.warn('Please select a size');
  //         return; // ❌ block add to cart
  //       }

  //       variantId = activeSize.dataset.variantId;
  //     } 
  //     // 🧠 Case 2: Product has NO variants
  //     else {
  //       variantId = button.dataset.variantId;
  //     }

  //     if (!variantId) {
  //       console.warn('Variant ID missing');
  //       return;
  //     }

  //     const productId = button.dataset.productId;
  //     const qty = button.dataset.quantity || '1';

  //     checkCartLimits(qty).then(cart => {
  //       if (!cart) return;

  //       const formData = new FormData();
  //       formData.append('id', variantId);
  //       formData.append('quantity', qty);
  //       formData.append('form_type', 'product');
  //       formData.append('utf8', '✓');
  //       if (productId) formData.append('product-id', productId);
  //       formData.append('section-id', 'template--17632417120300__main');

  //       console.log(formData);

  //       document.dispatchEvent(
  //         new CustomEvent('theme:cart:add', {
  //           detail: { button, formData },
  //           bubbles: false
  //         })
  //       );
  //     });
  //   });
  // });

  document.addEventListener('click', (e) => {
    const button = e.target.closest('.add-to-cart-btn');

    if (!button) return;

    e.preventDefault();

    const productCard = button.closest('.product-item');
    let variantId = null;

    if (productCard) {
      const sizeWrapper = productCard.querySelector('.product-card-sizes');

      if (sizeWrapper) {
        const activeSize = sizeWrapper.querySelector('.size-swatch.active');

        if (!activeSize) {
          console.warn('Please select a size');
          return;
        }

        variantId = activeSize.dataset.variantId;
      }
    }

    if (!variantId) {
      variantId = button.dataset.variantId;
    }

    if (!variantId) {
      console.warn('Variant ID missing');
      return;
    }

    const productId = button.dataset.productId;
    const qty = button.dataset.quantity || '1';

    checkCartLimits(qty).then(cart => {

      if (!cart) return;

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', qty);
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');

      if (productId) {
        formData.append('product-id', productId);
      }

      formData.append('section-id', 'template--17632417120300__main');

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          detail: { button, formData },
          bubbles: false
        })
      );
    });
  });
  // document.querySelectorAll('.add-to-cart-btn').forEach(button => {
  //   button.addEventListener('click', e => {
  //     e.preventDefault();

  //     const productCard = button.closest('.product-item'); // may be null
  //     let variantId = null;

  //     // Case 1: Button is inside a product card with sizes
  //     if (productCard) {
  //       const sizeWrapper = productCard.querySelector('.product-card-sizes');

  //       if (sizeWrapper) {
  //         const activeSize = sizeWrapper.querySelector('.size-swatch.active');

  //         if (!activeSize) {
  //           console.warn('Please select a size');
  //           return; // block add to cart
  //         }

  //         variantId = activeSize.dataset.variantId;
  //       }
  //     }

  //     // Case 2: No product card OR no size variants
  //     if (!variantId) {
  //       variantId = button.dataset.variantId;
  //     }

  //     if (!variantId) {
  //       console.warn('Variant ID missing');
  //       return;
  //     }

  //     const productId = button.dataset.productId;
  //     const qty = button.dataset.quantity || '1';

  //     checkCartLimits(qty).then(cart => {
  //       if (!cart) return;

  //       const formData = new FormData();
  //       formData.append('id', variantId);
  //       formData.append('quantity', qty);
  //       formData.append('form_type', 'product');
  //       formData.append('utf8', '✓');

  //       if (productId) formData.append('product-id', productId);
  //       formData.append('section-id', 'template--17632417120300__main');

  //       document.dispatchEvent(
  //         new CustomEvent('theme:cart:add', {
  //           detail: { button, formData },
  //           bubbles: false
  //         })
  //       );
  //     });
  //   });
  // });



});

// Extend add-to-cart functionality when product is added
document.addEventListener('theme:product:add', event => {
  
  const alertMsgWrapper = document.getElementById('product-update-alerts');
  const cartDrawer = document.querySelector('#cart-drawer');
  const cartDrawerOverlay = document.querySelector('.cart_drawer__overlay');
  if (cartDrawer) {
    event.preventDefault();
    cartDrawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show'));
    cartDrawerOverlay.classList.add('active');
  }
  const button = event.detail.button;
  const responseQty = event.detail.response.quantity;
  if (!button) return;
  const buttonId = button.getAttribute('data-variant-id');
  if (!buttonId) return;

  document.querySelectorAll(`button[data-variant-id="${buttonId}"]`).forEach(button => {
    button.classList.add('hide-atc_btn');
  });
  const upsellProduct = document.querySelector(`.upsell-product[data-product-id-upsell="${buttonId}"]`);
  if (upsellProduct) {
    const upsellProductParent = upsellProduct.closest('.upsell-products');
    const flktyInstance = Flickity.data(upsellProductParent);
    // upsellProduct.remove();
    if (flktyInstance) {
      setTimeout(() => {
        flktyInstance.reloadCells();
        flktyInstance.resize();
      }, 50);
    } else {
      console.warn("Flickity instance not found on upsell product parent.");
    }
  }

  document.querySelectorAll(`.quantity-wrapper[data-variant-id="${buttonId}"]`).forEach(wrapper => {
    if (!wrapper.classList.contains('active-qty')) {
      wrapper.classList.add('active-qty');
      wrapper.querySelector('.cart-quantity').textContent = responseQty;
    }
  });

  const qtyWrapper = button.parentElement.querySelector('.quantity-wrapper');
  if (qtyWrapper) {
    qtyWrapper.classList.add('active-qty');
    const variantId = button.getAttribute('data-variant-id');
    // Fetch latest cart data to update quantity
    checkCartLimits().then(cart => {
      if (cart && cart.items) {
        const cartItem = cart.items.find(item => item.id == variantId);
        if (cartItem) {
          const cartQuantityElem = qtyWrapper.querySelector('.cart-quantity');
          const productQuantityInc = qtyWrapper.querySelector('.increase-cart-qty');
          const productQuantityDec = qtyWrapper.querySelector('.decrease-cart-qty');

          if (cartQuantityElem) {
            cartQuantityElem.textContent = cartItem.quantity;
            qtyWrapper.setAttribute('data-key', cartItem.key);
          }
          if (productQuantityInc) {
            productQuantityInc.setAttribute('data-key', cartItem.key);
          }
          if (productQuantityDec) {
            productQuantityDec.setAttribute('data-key', cartItem.key);
          }
        }
      }
    });
  }
});


const isPDP = document.body.classList.contains('template-product');
const isMobile = window.matchMedia('(max-width: 767px)').matches;
const isMobilePDP = isPDP && isMobile;
const isSold = document.querySelector(".mobile-view #notify-me-btn");

console.log("isSold", isSold)
console.log("isMobilePDP", isMobilePDP);

if (isMobilePDP) {
  const atcBtn = document.querySelector(
    'body.template-product .sticky-addToCartBtn .add-to-cart-btn'
  );

  const qtyWrapper = document.querySelector(
    'body.template-product .sticky-addToCartBtn .quantity-wrapper'
  );
  const viewCartBtn = document.querySelector('.pdp-view-cart');

  if (!atcBtn || !qtyWrapper) {
    console.log('[Mobile PDP] ATC/quantity controls not available');
  } else {

    function getSelectedVariantId() {
      const checkedInput = document.querySelector(
        '[data-single-option-selector]:checked'
      );

      const variantId = checkedInput?.dataset.variantId || null;
      if (!variantId) {
        return;
      }
      if (variantId && atcBtn) { atcBtn.dataset.variantId = variantId; }

      console.log("checkedInput:", checkedInput);
      console.log("checked variant ID:", checkedInput?.dataset.variantId);

      return checkedInput?.dataset.variantId || null;
    }

    function updateUI(cart, variantId) {

      console.log("Selected variant ID:", variantId);
      console.log("Cart items:", cart.items);

      // Reset previous variant UI
      atcBtn.classList.remove('hide-atc_btn');
      qtyWrapper.classList.remove('active-qty');

      qtyWrapper.removeAttribute('data-key');

      const plusBtn = qtyWrapper.querySelector('.increase-cart-qty');
      const minusBtn = qtyWrapper.querySelector('.decrease-cart-qty');
      const qtyEl = qtyWrapper.querySelector('.cart-quantity');

      if (plusBtn) {
        plusBtn.removeAttribute('data-key');
        plusBtn.dataset.variantId = variantId;
      }

      if (minusBtn) {
        minusBtn.removeAttribute('data-key');
        minusBtn.dataset.variantId = variantId;
      }

      // Find selected variant in cart
      const item = cart.items.find(function (item) {
        return String(item.variant_id) === String(variantId);
      });

      console.log("Cart item:", item);

      if (item) {

        console.log("VARIANT EXISTS IN CART");

        atcBtn.classList.add('hide-atc_btn');
        qtyWrapper.classList.add('active-qty');

        qtyWrapper.dataset.variantId = variantId;
        qtyWrapper.dataset.key = item.key;

        if (qtyEl) {
          qtyEl.textContent = item.quantity;
        }

        if (plusBtn) {
          plusBtn.dataset.key = item.key;
        }

        if (minusBtn) {
          minusBtn.dataset.key = item.key;
        }

      } else {

        console.log("VARIANT NOT IN CART");

        // Show ATC for new variant
        atcBtn.classList.remove('hide-atc_btn');
        qtyWrapper.classList.remove('active-qty');

        if (qtyEl) {
          qtyEl.textContent = '1';
        }
      }
    }

    function syncUI() {

      const variantId = getSelectedVariantId();

      console.log("variantId:", variantId);

      if (!variantId) return;

      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          updateUI(cart, variantId);
        });
    }

    syncUI();

    atcBtn.addEventListener('click', e => {
      e.preventDefault();

      const variantId = getSelectedVariantId();
      if (!variantId) {
        console.warn('No variant selected');
        return;
      }

      const qty = atcBtn.dataset.quantity || '1';
      const productId = atcBtn.dataset.productId;

      checkCartLimits(qty).then(cart => {
        if (!cart) return;

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', qty);
        formData.append('form_type', 'product');
        formData.append('utf8', '✓');
        if (productId) formData.append('product-id', productId);

        document.dispatchEvent(
          new CustomEvent('theme:cart:add', {
            detail: { button: atcBtn, formData },
            bubbles: false
          })
        );

        // Re-sync after add
        setTimeout(syncUI, 300);
      });
    });

    document.addEventListener('change', e => {
      if (e.target.matches('[data-single-option-selector]')) {
        atcBtn.classList.remove('hide-atc_btn');
        qtyWrapper.classList.remove('active-qty');
        syncUI();
      }
    });
  }
}

//cart quantity mobile pdp
if (isMobilePDP) {
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".quantity-wrapper").forEach(wrapper => {
      const decreaseBtn = wrapper.querySelector(".decrease-cart-qty");
      const increaseBtn = wrapper.querySelector(".increase-cart-qty");
      if (decreaseBtn) {
        decreaseBtn.addEventListener("click", (event) => {
          const itemCartKey = event.currentTarget.getAttribute('data-variant-id');
          increaseBtn?.removeAttribute('disabled');
          const cartQuantity = document.querySelector(`.cart__quantity-minus[data-productitem-id="${itemCartKey}"]`);
          if (cartQuantity) {
            cartQuantity.click();
          }
          else {
            event.target.closest(".quantity-wrapper")?.classList.remove("active-qty");
            const parentElement = event.currentTarget.closest(".quantity-wrapper")?.parentElement?.parentElement;
            if (parentElement) {
              parentElement.querySelector('.add-to-cart-btn').classList.remove('hide-atc_btn');
            }
          }
        });
      }
      if (increaseBtn) {
        increaseBtn.addEventListener("click", (event) => {
          const itemCartKey = event.currentTarget.getAttribute('data-variant-id');
          const cartQuantity = document.querySelector(`.cart__quantity-plus[data-productitem-id="${itemCartKey}"]`);
          if (cartQuantity) {
            cartQuantity.click();
          }
        });
      }
    });
  });
}
else {
  console.log("else condition ")
  // Cart quantity counter
  document.addEventListener("click", function (event) {

    // Cart quantity counter (Wizzy search/autocomplete tiles use handlers in wizzyCustom.js)
    if (event.target.closest(".wizzy-result-product, .topproduct-item, .upsell-product") && (event.target.closest(".decrease-cart-qty") || event.target.closest(".increase-cart-qty"))) {
      return;
    }

    if (event.target.closest(".decrease-cart-qty")) {
      const decreaseBtn = event.target.closest(".decrease-cart-qty");
      const wrapper = decreaseBtn.closest(".quantity-wrapper");
      if (!wrapper) return;
      const variantId = wrapper.getAttribute("data-variant-id");
      const cartQuantity = document.querySelector(
        `.cart__quantity-minus[data-productitem-id="${variantId}"]`
      );
      if (cartQuantity) {
        cartQuantity.click();
      } else {
        wrapper.classList.remove("active-qty");
        const parentElement = wrapper?.parentElement?.parentElement;
        if (parentElement) {
          parentElement
            .querySelector(".add-to-cart-btn")
            ?.classList.remove("hide-atc_btn");
        }
      }
    }
    if (event.target.closest(".increase-cart-qty")) {
      const increaseBtn = event.target.closest(".increase-cart-qty");
      const wrapper = increaseBtn.closest(".quantity-wrapper");
      if (!wrapper) return;
      const variantId = wrapper.getAttribute("data-variant-id");
      const cartQuantity = document.querySelector(
        `.cart__quantity-plus[data-productitem-id="${variantId}"]`
      );
      if (cartQuantity) {
        cartQuantity.click();
      }
    }
  });
}
// document.addEventListener("DOMContentLoaded", function () {

// //   const checkoutButton = document.querySelector('.cart__checkout');
// //   const selectors = ['.cart__quantity-minus', '.cart__quantity-plus', '.cart__item__remove'];

// //   // 1. On Checkout Button Click: Disable other buttons temporarily
// //   if (checkoutButton) {
// //     checkoutButton.addEventListener('click', () => {
// //       selectors.forEach(selector => {
// //         document.querySelectorAll(selector).forEach(element => {
// //           element.style.pointerEvents = 'none';
// //           element.style.cursor = 'wait';
// //         });
// //       });

// //       setTimeout(() => {
// //         selectors.forEach(selector => {
// //           document.querySelectorAll(selector).forEach(element => {
// //             element.style.pointerEvents = 'auto';
// //             element.style.cursor = 'pointer';
// //           });
// //         });
// //       }, 4000); // Re-enable after 2s
// //     });
// //   }

// //   // 2. On Quantity/Remove Click: Disable Checkout Button temporarily
// //   selectors.forEach(selector => {
// //     document.querySelectorAll(selector).forEach(element => {
// //       element.addEventListener('click', () => {       
// //           checkoutButton.classList.add('disabled_checkout');
// //       });
// //     });
// //   });



// //   const freeGiftThreshold = window.theme?.cartDiscounts?.free_product_threshold || 900;
// //   const freeGiftThresholdNumber = window.theme?.cartDiscounts?.free_product_threshold_number || 2;
// //   const freeGiftSuccessMessage = window.theme?.cartDiscounts?.single_freebie_dynamic_cart_message_second || "Yay! Your freebie is added to the cart!";
// //   const freeGiftErrorMessage = window.theme?.cartDiscounts?.single_free_dynamic_cart_message || "Yay! Your freebie is added to the cart!";

// //   // const offerMessageFree = document.querySelector(".autofreebie ");

// //   function waitForClass(el, className, callback, retries = 5) {
// //     if (el.classList.contains(className)) {
// //       callback();
// //     } else if (retries > 0) {
// //       setTimeout(() => waitForClass(el, className, callback, retries - 1), 100);
// //     }
// //   }

// //   function waitForElement(selector, callback, retries = 10, interval = 100) {
// //   const el = document.querySelector(selector);
// //   if (el) {
// //     callback(el);
// //   } else if (retries > 0) {
// //     setTimeout(() => waitForElement(selector, callback, retries - 1, interval), interval);
// //   } else {
// //     console.warn(`Element ${selector} not found after waiting.`);
// //   }
// // }

// //   function freebieAddToCart() {
// //     const freebieElement = document.querySelector(".freebie-single-product");
// //     if (!freebieElement) return console.error("Freebie element not found.");

// //     const freebieProductId = freebieElement.dataset.productId;
// //     const variantId = freebieElement.querySelector("button[data-variant-id]")?.getAttribute("data-variant-id");


// //     if (!freebieProductId || !variantId) {
// //       return console.error("Freebie product or variant ID not found.");
// //     }

// //     const offerMessageFree = document.querySelector(".autofreebie");
// //     const addBtn = freebieElement.querySelector(".add-to-cart-btn");
// //     const freebieProduct = document.querySelector('.cart__item.freeItem.true');
// //     const checkout_button = document.querySelector('.cart__checkout');

// //     if(!freebieProduct) {
// //       checkout_button.classList.add('disabled_checkout');
// //       offerMessageFree?.classList.remove("is-success");
// //       offerMessageFree?.classList.add("is-loading");
// //       offerMessageFree.textContent = freeGiftErrorMessage;
// //       setTimeout(() => {
// //         checkout_button.classList.remove('disabled_checkout');
// //       },3000)

// //     }

// //     fetch("/cart.js")
// //       .then(res => res.json())
// //       .then(cart => {
// //         const totalQuantity = cart.items.reduce((sum, item) => sum + item.quantity, 0);
// //         const isFreebieInCart = cart.items.some(item => item.product_id == freebieProductId);
// //         const totalEligibleQuantity = getCartTotalQty();
// //         console.log(totalEligibleQuantity);
// //         const announcementBarSecondary = document.getElementById('cart-announcement-bar-2');
// //         console.log(isFreebieInCart);

// //         if (totalEligibleQuantity >= freeGiftThresholdNumber && !isFreebieInCart) {
// //           if (addBtn) {
// //             addBtn.click();
// //             checkout_button.classList.add('disabled_checkout');
// //             setTimeout(() => {
// //               offerMessageFree?.classList.remove("is-loading");
// //               offerMessageFree?.classList.add("is-success");
// //               offerMessageFree.textContent = freeGiftSuccessMessage;

// //             }, 2000);
// //             setTimeout(() => {
// //               checkout_button.classList.remove('disabled_checkout');
// //             },3000);
// //           } else {
// //             console.error("Add to cart button not found.");
// //           }
// //         }
// //         if (totalEligibleQuantity > freeGiftThresholdNumber && isFreebieInCart) {
// //           setTimeout(() => {
// //               checkout_button.classList.remove('disabled_checkout');
// //           },3000);
// //         }
// //          // Code Author - Rafid
// //         const hasValidSummerOffer = cart.items.some(item =>
// //           item.product_id != freebieProductId &&
// //           item.discounts?.some(discount => discount.title === 'JUNE OFFER')
// //         );
// //         const hasSerum = cart.items.some(item => item.product_title.toLowerCase().includes('serum'));

// //         if (hasValidSummerOffer == true) {
// //           announcementBarSecondary.innerText = `Yay! You got Rs.100 off on sunsreen`;
// //           announcementBarSecondary.style.backgroundColor = '#d1fae5';
// //         } else if(hasValidSummerOffer == false && hasSerum == true) {
// //           announcementBarSecondary.innerText = `Add any Sunscreen & get extra Rs.100 off `;
// //           announcementBarSecondary.style.backgroundColor = '#fff';
// //         } else if(hasValidSummerOffer == false && hasSerum == false){
// //           announcementBarSecondary.innerText = `Buy any Serum & get extra Rs.100 off on any Sunscreen`;
// //           announcementBarSecondary.style.backgroundColor = '#fff';
// //           }


// //         // End Code Author - Rafid



// //         if (isFreebieInCart && totalEligibleQuantity < freeGiftThresholdNumber) {
// //           checkout_button.classList.add('disabled_checkout');
// //           const offerMessageFree = document.querySelector(".autofreebie");
// //           offerMessageFree?.classList.remove("is-success");
// //           // offerMessageFree.textContent = "Freebie is getting removed!";

// //           // const removeButton = document.querySelector(`.cart__item__remove[data-productitem-id="${variantId}"]`);
// //           // removeButton.click();

// //           waitForElement(`[data-productitem-id="${variantId}"]`, (removeBtn) => {
// //             removeBtn.click();
// //           });
// //         }
// //         const freeItem = document.querySelector('.cart__item.freeItem');
// //         const cartItemsContainer = document.querySelector('.drawer__items');
// //         if (freeItem && cartItemsContainer) {
// //           cartItemsContainer.prepend(freeItem);
// //         }
// //       })
// //       .catch(err => console.error("Error fetching cart:", err));
// //   }

// //   const getCartTotal = () => {
// //     const cartTotalEl = document.querySelector(".cart__total__money[data-cart-total]");
// //     return cartTotalEl ? parseFloat(cartTotalEl.textContent.replace(/[^0-9.]/g, "")) || 0 : 0;
// //   };

// //   const getCartTotalQty = () => {
// //     let totalQty = 0;
// //     document.querySelectorAll(".cart__item.false.single .cart__quantity-field").forEach(input => {
// //         totalQty += parseInt(input.value, 10) || 0;
// //     });
// //     return totalQty;
// //   };

// //   function observeCartUpdates() {
// //     const cartDrawer = document.querySelector(".drawer--cart");
// //     if (!cartDrawer) return console.error("Cart drawer not found.");

// //     const observer = new MutationObserver((mutationsList) => {
// //       for (const mutation of mutationsList) {
// //         if (mutation.type === "attributes" && mutation.attributeName === "class") {
// //           if (cartDrawer.classList.contains("is-open")) {
// //             const freebieProduct = document.querySelector(".cart__item.freeItem");
// //             const cartNudge = document.querySelector(".autofreebie");

// //             if (freebieProduct && cartNudge instanceof Element) {
// //               waitForClass(cartNudge, "is-loading", () => {
// //                 cartNudge.classList.remove("is-loading");
// //                 cartNudge.classList.add("is-success");
// //               });
// //             }
// //             const upsellCarousel = document.querySelector(".upsell-products");
// //             if (upsellCarousel) {
// //               const flktyInstance = Flickity.data(upsellCarousel);

// //               if (flktyInstance) {
// //                 flktyInstance.reloadCells();
// //                 flktyInstance.resize();
// //               }
// //             }

// //           }

// //         }
// //       }
// //       freebieAddToCart();
// //       updateDiscountButtonsBasedOnCart();
// //     });

// //     observer.observe(cartDrawer, { attributes: true });
// //   }

// //   observeCartUpdates();
// });


document.addEventListener("DOMContentLoaded", function () {
  const cartWrapper = document.querySelector(".cart_discount_wrapper");
  const discountPopup = document.querySelector(".discount-popup");
  const overlay = document.querySelector(".cart-inner-discount-underlay");
  const discountPopupCloseBtn = document.querySelector(".discount_modal_close");

  if (cartWrapper && discountPopup && overlay) {
    cartWrapper.addEventListener("click", function (event) {
      const appliedDiscount = localStorage.getItem("appliedDiscount");
      if (appliedDiscount) {
        // document.querySelector('.discount-card[data-discount-code="' + appliedDiscount + '"]').classList.add("is-applied");
        // document.querySelector('.discount-card[data-discount-code="' + appliedDiscount + '"] .discount-card-apply').textContent = "Applied";
        // document.querySelector('.discount-card[data-discount-code="' + appliedDiscount + '"] .discount-card-apply').setAttribute('disabled', 'disabled');
        document.querySelector('.discount-input').value = appliedDiscount;
        document.querySelector('.discount-apply').style.display = "block";
        // document.querySelector('.discount-remove').style.display = "block";
      }

      event.stopPropagation();
      discountPopup.style.display = "flex";

      setTimeout(() => {
        discountPopup.style.transform = "translateY(0)";
        discountPopup.style.transition = "transform 0.4s ease-in-out";
      }, 10);

      overlay.style.visibility = "visible";
      overlay.style.opacity = "1";
    });

    function closePopup() {
      discountPopup.style.transform = "translateY(100%)";
      overlay.style.opacity = "0";

      setTimeout(() => {
        discountPopup.style.display = "none";
        overlay.style.visibility = "hidden";
      }, 400);
    }
    overlay.addEventListener("click", closePopup);
    discountPopupCloseBtn.addEventListener("click", closePopup);
    document.body.addEventListener("click", function (event) {
      if (!discountPopup.contains(event.target) && !cartWrapper.contains(event.target)) {
        closePopup();
      }
    });
  }
});

function updateCartSavings() {
  const drawerMain = document.querySelector('.cart_drawer');
  const section_id = drawerMain.getAttribute('data-section-id');
  fetch(`/?section_id=${section_id}`) // or correct section ID
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newSavings = doc.querySelector('#cart-total-savings');

      const currentSavings = document.querySelector('#cart-total-savings');
      if (currentSavings && newSavings) {
        currentSavings.innerHTML = newSavings.innerHTML;
      }
    });
}



document.addEventListener("DOMContentLoaded", function () {

  /* CART PROGRESS */

  const stepsContainer = document.querySelector(".cart_progress__steps");

  if (stepsContainer) {

    const steps = stepsContainer.querySelectorAll(".step");
    const stepCount = steps.length;

    if (stepCount) {
      steps.forEach((step, index) => {
        const position = ((index + 1) / stepCount) * 100;

        step.style.position = "absolute";
        step.style.left = `${position}%`;
        step.style.transform = "translateX(-50%)";
      });
    }
  }

  window._isCartUpdating = false;
  window._isFreebieUpdating = false;
  window._isFreebieLogicRunning = false;

  const checkoutButton = document.querySelector(".cart__checkout");

  /* CHECKOUT DISABLED OVERLAY */

  function createCheckoutOverlay() {
    const cartDrawer = document.querySelector(".drawer--cart .drawer__inner");

    if (!cartDrawer) {
      return null;
    }

    let overlay = cartDrawer.querySelector(".cart-disabled-overlay");

    if (!overlay) {
      overlay = document.createElement("div");
      overlay.className = "cart-disabled-overlay";

      overlay.innerHTML = `
      <div class="cart-disabled-overlay__content">
        <span class="cart-disabled-overlay__spinner"></span>
      </div>
    `;

      cartDrawer.appendChild(overlay);
    }

    return overlay;
  }


  function updateCheckoutOverlay() {
    const overlay = createCheckoutOverlay();

    if (!overlay) {
      return;
    }

    const button = document.querySelector(".cart__checkout");

    if (!button) {
      overlay.classList.remove("is-visible");
      return;
    }

    const isCheckoutDisabled =
      button.classList.contains("disabled_checkout");

    const hasRegularProducts =
      document.querySelectorAll(".cart__item.false").length > 0;

    const hasFreebies =
      document.querySelectorAll(".cart__item.true.freeItem").length > 0;

    const hasCartItems =
      hasRegularProducts || hasFreebies;

    if (isCheckoutDisabled && hasCartItems) {
      overlay.classList.add("is-visible");
    } else {
      overlay.classList.remove("is-visible");
    }
  }


  /*
   * Observe the CART DRAWER instead of the checkout button.
   *
   * The checkout button can be replaced when the cart drawer
   * is refreshed, so observing the button itself is unreliable.
   */
  function observeCheckoutOverlay() {
    const cartDrawer = document.querySelector(".drawer--cart");

    if (!cartDrawer) {
      return;
    }

    let updateTimer = null;

    const scheduleOverlayUpdate = () => {
      clearTimeout(updateTimer);

      updateTimer = setTimeout(() => {
        updateCheckoutOverlay();
      }, 0);
    };

    const observer = new MutationObserver(function (mutations) {
      let shouldUpdate = false;

      mutations.forEach(function (mutation) {
        /*
         * Checkout button class changed
         */
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          shouldUpdate = true;
        }

        /*
         * Cart drawer was re-rendered and the checkout button
         * may have been replaced.
         */
        if (mutation.type === "childList") {
          shouldUpdate = true;
        }
      });

      if (shouldUpdate) {
        scheduleOverlayUpdate();
      }
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });

    updateCheckoutOverlay();
  }

  observeCheckoutOverlay();


  const cartUpdateSelectors = [
    ".cart__quantity-minus",
    ".cart__quantity-plus",
    ".cart__item__remove"
  ];


  /*
   * Disable quantity/remove buttons while checkout is clicked
   */
  if (checkoutButton) {

    checkoutButton.addEventListener("click", function () {

      cartUpdateSelectors.forEach(selector => {

        document.querySelectorAll(selector).forEach(element => {

          element.style.pointerEvents = "none";
          element.style.cursor = "wait";

        });

      });


      setTimeout(() => {

        cartUpdateSelectors.forEach(selector => {

          document.querySelectorAll(selector).forEach(element => {

            element.style.pointerEvents = "auto";
            element.style.cursor = "pointer";

          });

        });

      }, 4000);

    });

  }


  /*
   * Quantity / remove click
   */
  document.addEventListener("click", function (event) {

    const clickedCartControl = cartUpdateSelectors.some(selector =>
      event.target.closest(selector)
    );

    if (clickedCartControl) {

      window._isCartUpdating = true;

      checkoutButton?.classList.add("disabled_checkout");

    }

  });


  /*
   * Quantity input change
   */
  document.addEventListener("change", function (event) {

    if (
      event.target.classList.contains("cart__quantity-field")
    ) {

      window._isCartUpdating = true;

      checkoutButton?.classList.add("disabled_checkout");

    }

  });

  /*
   * OFFER FLOW
   *
   * ₹499  -> Secondary freebie
   * ₹799  -> freebie_set1 becomes claimable
   * ₹999  -> Main automatic freebie
   */

  const firstSetCartValue = window.theme?.cartDiscounts?.free_product_threshold;
  const secondSetCartValue = window.theme?.cartDiscounts?.free_product_threshold_2;
  const freebieSet1CartValue = 799;

  console.log("firstSetCartValue", firstSetCartValue)
  console.log("secondSetCartValue", secondSetCartValue)


  const freeGiftSuccessMessage =
    window.theme?.cartDiscounts?.single_freebie_dynamic_cart_message_second ||
    "Your freebie is added to the cart!";

  const freeGiftErrorMessage =
    window.theme?.cartDiscounts?.single_free_dynamic_cart_message ||
    "Your freebie is added to the cart!";

  const freebieElement =
    document.querySelector(".freebie-single-product");

  const freebieProductId =
    freebieElement?.dataset.productId;

  const freebieVariantId =
    freebieElement
      ?.querySelector("button[data-variant-id]")
      ?.getAttribute("data-variant-id");

  console.log("freebieElement",)
  /*
   * Secondary freebie - ₹499
   */

  const freebieElementSecondary =
    document.querySelector(".freebie-single-product--secondary");

  const freebieSecondaryProductId =
    freebieElementSecondary?.dataset.productId;

  const freebieSecondaryVariantId =
    freebieElementSecondary
      ?.querySelector("button[data-variant-id]")
      ?.getAttribute("data-variant-id");

  console.log("freebieElementSecondary", freebieElementSecondary)


  /*
   * Freebie set 1 - ₹799
   */

  const firstSetProductContainer =
    document.querySelector(".freebie_set1");

  const secondSetProductContainer =
    document.querySelector(".freebie_set2");

  const thirdSetProductContainer =
    document.querySelector(".freebie_set3");


  const firstSetProductIdElements =
    document.querySelectorAll(
      ".freebie_set1 [data-product-id]"
    );

  const firstSetProductIds =
    Array.from(firstSetProductIdElements).map(
      el => el.getAttribute("data-product-id")
    );


  const secondSetProductIdElements =
    document.querySelectorAll(
      ".freebie_set2 [data-product-id]"
    );

  const secondSetProductIds =
    Array.from(secondSetProductIdElements).map(
      el => el.getAttribute("data-product-id")
    );


  const thirdSetProductIdElements =
    document.querySelectorAll(
      ".freebie_set3 [data-product-id]"
    );

  const thirdSetProductIds =
    Array.from(thirdSetProductIdElements).map(
      el => el.getAttribute("data-product-id")
    );


  const firstSetVariantIds =
    Array.from(
      document.querySelectorAll(
        ".freebie_set1 [data-product-id]"
      )
    )
      .map(el => el.getAttribute("data-variant-id"))
      .filter(Boolean);


  const secondSetVariantIds =
    Array.from(
      document.querySelectorAll(
        ".freebie_set2 [data-product-id]"
      )
    )
      .map(el => el.getAttribute("data-variant-id"))
      .filter(Boolean);


  const thirdSetVariantIds =
    Array.from(
      document.querySelectorAll(
        ".freebie_set3 [data-product-id]"
      )
    )
      .map(el => el.getAttribute("data-variant-id"))
      .filter(Boolean);

  const sunscreenFreebie =
    document.querySelector(".freebie-product-set.product-1");

  const sunscreenFreebieProductId =
    sunscreenFreebie?.dataset.productId;

  const sunscreenFreebieVariantId =
    sunscreenFreebie
      ?.querySelector("button[data-variant-id]")
      ?.getAttribute("data-variant-id");

  const sunscreenFreebieInventory =
    sunscreenFreebie?.dataset.productInventory;

  const sunscreenFreebieThreshold =
    sunscreenFreebie?.dataset.productThreshold;

  const sunscreenFreebieAddBtn =
    sunscreenFreebie?.querySelector(".add-to-cart-btn");


  const toteBagFreebie =
    document.querySelector(".freebie-product-set.product-2");

  const toteBagFreebieProductId =
    toteBagFreebie?.dataset.productId;

  const toteBagFreebieVariantId =
    toteBagFreebie
      ?.querySelector("button[data-variant-id]")
      ?.getAttribute("data-variant-id");

  const toteBagFreebieInventory =
    toteBagFreebie?.dataset.productInventory;

  const toteBagFreebieThreshold =
    toteBagFreebie?.dataset.productThreshold;

  const toteBagFreebieAddBtn =
    toteBagFreebie?.querySelector(".add-to-cart-btn");

  function wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  function waitForElement(
    selector,
    callback,
    retries = 10,
    interval = 100
  ) {

    const element = document.querySelector(selector);

    if (element) {

      callback(element);

    } else if (retries > 0) {

      setTimeout(
        () => waitForElement(
          selector,
          callback,
          retries - 1,
          interval
        ),
        interval
      );

    }

  }


  function waitForClass(
    element,
    className,
    callback,
    retries = 5
  ) {

    if (!element) return;

    if (element.classList.contains(className)) {

      callback();

    } else if (retries > 0) {

      setTimeout(
        () => waitForClass(
          element,
          className,
          callback,
          retries - 1
        ),
        100
      );

    }

  }

  const getCartTotal = () => {

    const cartTotalEl =
      document.querySelector(
        ".cart__total__money[data-cart-total]"
      );

    if (!cartTotalEl) return 0;

    return (
      parseFloat(
        cartTotalEl.textContent.replace(
          /[^0-9.]/g,
          ""
        )
      ) || 0
    );

  };


  /*
   * Calculate eligible cart total.
   *
   * Existing theme structure is retained:
   * .cart__item.true = freebie
   *
   * data-item-price is used only to subtract
   * freebie values from the displayed cart total.
   */

  const getEligibleCartTotal = () => {

    const cartTotalEl =
      document.querySelector(
        ".cart__total__price--final[data-cart-total]"
      );

    if (!cartTotalEl) return 0;

    const cartTotal =
      parseFloat(
        cartTotalEl.textContent.replace(
          /[^0-9.]/g,
          ""
        )
      ) || 0;


    const trueItemEls =
      document.querySelectorAll(
        ".cart__item.true[data-item-price]"
      );


    let trueItemTotal = 0;


    trueItemEls.forEach(el => {

      const rawValue =
        el.getAttribute("data-item-price") || "0";

      const cleaned =
        rawValue.replace(/[^0-9]/g, "");

      /*
       * Existing Shopify markup stores the amount
       * with the last two digits representing decimals.
       */

      const withoutLastTwo =
        cleaned.length > 2
          ? cleaned.slice(0, -2)
          : "0";

      const value =
        parseFloat(withoutLastTwo) || 0;

      trueItemTotal += value;

    });


    return Math.max(
      cartTotal - trueItemTotal,
      0
    );

  };

  const getCartTotalQty = () => {

    let totalQty = 0;

    document
      .querySelectorAll(".cart__item.false")
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        const isCombo =
          item.classList.contains("combo");

        totalQty +=
          qty * (isCombo ? 2 : 1);

      });

    return totalQty;

  };


  const getCartTotalFreebieQty = () => {

    let totalQty = 0;

    document
      .querySelectorAll(
        ".cart__item.true.freeItem"
      )
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        const isCombo =
          item.classList.contains("combo");

        totalQty +=
          qty * (isCombo ? 2 : 1);

      });

    return totalQty;

  };


  const getPouchTotalQty = () => {

    let totalQty = 0;

    if (!freebieSecondaryVariantId) {
      return totalQty;
    }

    document
      .querySelectorAll(
        `.cart__item.true[data-variant-id="${freebieSecondaryVariantId}"]`
      )
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        totalQty += qty;

      });

    return totalQty;

  };


  const getSunscreenTotalQty = () => {

    let totalQty = 0;

    if (!sunscreenFreebieVariantId) {
      return totalQty;
    }

    document
      .querySelectorAll(
        `.cart__item.true[data-variant-id="${sunscreenFreebieVariantId}"]`
      )
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        totalQty += qty;

      });

    return totalQty;

  };


  const getToteBagTotalQty = () => {

    let totalQty = 0;

    if (!toteBagFreebieVariantId) {
      return totalQty;
    }

    document
      .querySelectorAll(
        `.cart__item.true[data-variant-id="${toteBagFreebieVariantId}"]`
      )
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        totalQty += qty;

      });

    return totalQty;

  };


  const getSerumTotalQty = () => {

    let totalQty = 0;

    document
      .querySelectorAll(
        ".cart__item.false.serum"
      )
      .forEach(item => {

        const quantityInput =
          item.querySelector(
            ".cart__quantity-field"
          );

        const qty =
          parseInt(
            quantityInput?.value,
            10
          ) || 0;

        totalQty += qty;

      });

    return totalQty;

  };

  async function getCurrentCart() {

    const response =
      await fetch(
        "/cart.js",
        {
          cache: "no-store"
        }
      );

    if (!response.ok) {
      throw new Error(
        "Unable to fetch cart"
      );
    }

    return response.json();

  }


  /*
   * Check whether variant exists in cart
   */

  function cartHasVariant(cart, variantId) {

    if (!variantId) return false;

    return cart.items.some(
      item =>
        String(item.variant_id) ===
        String(variantId)
    );

  }

  async function ensureOnlyOneSet1Freebie() {

    try {

      const cart = await getCurrentCart();

      const set1Items = getSet1ItemsInCart(cart);

      /*
       * Nothing to clean up
       */
      if (set1Items.length <= 1) {
        return cart;
      }

      console.warn(
        "Multiple Set 1 freebies detected. Cleaning up:",
        set1Items
      );

      /*
       * Keep only ONE freebie.
       *
       * If there is already a selected/claimed freebie,
       * the first one is retained.
       */
      const itemToKeep = set1Items[0];

      /*
       * Remove every additional Set 1 freebie
       */
      for (let i = 1; i < set1Items.length; i++) {

        const duplicateItem = set1Items[i];

        console.log(
          "Removing duplicate Set 1 freebie:",
          duplicateItem.variant_id
        );

        const response = await fetch(
          "/cart/change.js",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
            },
            body: JSON.stringify({
              id: duplicateItem.key,
              quantity: 0
            })
          }
        );

        if (!response.ok) {
          throw new Error(
            `Unable to remove duplicate freebie ${duplicateItem.variant_id}`
          );
        }

      }

      /*
       * Verify Shopify cart again
       */
      const finalCart =
        await getCurrentCart();

      const remainingSet1Items =
        getSet1ItemsInCart(finalCart);

      /*
       * Safety check
       */
      if (remainingSet1Items.length > 1) {

        console.warn(
          "Set 1 duplicate still exists after cleanup."
        );

      }

      /*
       * Refresh cart UI only after cleanup
       */
      document.dispatchEvent(
        new CustomEvent(
          "theme:cart:refresh"
        )
      );

      return finalCart;

    } catch (error) {

      console.error(
        "Set 1 freebie duplicate cleanup error:",
        error
      );

      return null;
    }
  }


  /*
   * Get all freebie_set1 variants currently in cart
   */

  function getSet1ItemsInCart(cart) {

    return cart.items.filter(item =>
      firstSetVariantIds.some(
        id =>
          String(id) ===
          String(item.variant_id)
      )
    );

  }


  /* ADD TO CART */

  async function addToCart(variantId) {

    if (!variantId) {
      throw new Error(
        "Missing variant ID"
      );
    }


    window._isFreebieUpdating = true;

    checkoutButton?.classList.add(
      "disabled_checkout"
    );


    try {

      const cart =
        await getCurrentCart();


      const existingItem =
        cart.items.find(
          item =>
            String(item.variant_id) ===
            String(variantId)
        );


      let response;


      if (existingItem) {

        /*
         * Already exists.
         * Force quantity to 1.
         */

        response =
          await fetch(
            "/cart/change.js",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },
              body: JSON.stringify({
                id: existingItem.key,
                quantity: 1
              })
            }
          );

      } else {

        response =
          await fetch(
            "/cart/add.js",
            {
              method: "POST",
              headers: {
                "Content-Type":
                  "application/json",
                "Accept":
                  "application/json"
              },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1
                  }
                ]
              })
            }
          );

      }


      if (!response.ok) {

        const errorText =
          await response.text();

        throw new Error(
          `Failed to add freebie: ${errorText}`
        );

      }


      /*
       * Tell theme to refresh cart drawer
       */

      // Trigger drawer refresh
      document.dispatchEvent(
        new CustomEvent('theme:cart:refresh')
      );

      // If this is a freebie from freebie_set1,
      // mark it as CLAIMED after cart UI refresh
      if (firstSetVariantIds.includes(String(variantId))) {
        setTimeout(() => {
          markFreebieAsClaimed(variantId);
        }, 500);

        setTimeout(() => {
          markFreebieAsClaimed(variantId);
        }, 1200);
      }

      return response;

    } catch (error) {

      console.error(
        "addToCart error:",
        error
      );

      throw error;

    }

  }

  function markFreebieAsClaimed(variantId) {
    if (!variantId) return;

    const variantIdString = String(variantId);

    /*
     * Find the claim button directly using its variant ID
     */
    const claimButton = document.querySelector(
      `.freebie_set1 .claim-btn[data-variant-id="${variantIdString}"]`
    );

    if (claimButton) {
      claimButton.classList.add("claimed");
      claimButton.classList.remove("disabled");

      claimButton.setAttribute("disabled", "disabled");
      // claimButton.style.pointerEvents = "none";
      // claimButton.style.opacity = "0.6";

      const btnText = claimButton.querySelector(".btn__text");

      if (btnText) {
        btnText.textContent = "CLAIMED";
      } else {
        claimButton.textContent = "CLAIMED";
      }
    }
  }

  function resetFreebieClaimButton(variantId) {
    if (!variantId) return;

    const variantIdString = String(variantId);

    const claimButton = document.querySelector(
      `.freebie_set1 .claim-btn[data-variant-id="${variantIdString}"]`
    );

    if (!claimButton) return;

    claimButton.classList.remove("claimed");

    claimButton.removeAttribute("disabled");

    const btnText = claimButton.querySelector(".btn__text");

    if (btnText) {
      btnText.textContent = "CLAIM";
    } else {
      claimButton.textContent = "CLAIM";
    }
  }

  async function updateClaimedFreebieState() {
    try {
      const cart = await getCurrentCart();

      cart.items.forEach(item => {
        const variantId = String(item.variant_id);

        if (
          firstSetVariantIds.some(
            id => String(id) === variantId
          )
        ) {
          markFreebieAsClaimed(variantId);
        }
      });

    } catch (error) {
      console.error(
        "Error updating claimed freebie state:",
        error
      );
    }
  }

  async function deleteFromCart(variantId) {

    if (!variantId) {
      return;
    }


    window._isFreebieUpdating = true;

    checkoutButton?.classList.add(
      "disabled_checkout"
    );


    try {

      const response =
        await fetch(
          "/cart/update.js",
          {
            method: "POST",
            headers: {
              "Content-Type":
                "application/json",
              "Accept":
                "application/json"
            },
            body: JSON.stringify({
              updates: {
                [variantId]: 0
              }
            })
          }
        );


      if (!response.ok) {

        throw new Error(
          "Failed to remove item"
        );

      }


      const data =
        await response.json();


      /*
       * Refresh cart drawer
       */

      document.dispatchEvent(
        new CustomEvent(
          "theme:cart:refresh"
        )
      );


      return data;

    } catch (error) {

      console.error(
        "deleteFromCart error:",
        error
      );

      throw error;

    }

  }

  async function setLineItemQtyToOne(
    variantId
  ) {

    if (!variantId) {
      return;
    }


    const cart =
      await getCurrentCart();


    const lineItem =
      cart.items.find(
        item =>
          String(item.variant_id) ===
          String(variantId)
      );


    if (!lineItem) {
      return;
    }


    if (lineItem.quantity <= 1) {
      return;
    }


    const response =
      await fetch(
        "/cart/change.js",
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            "Accept":
              "application/json"
          },
          body: JSON.stringify({
            id: lineItem.key,
            quantity: 1
          })
        }
      );


    if (!response.ok) {
      throw new Error(
        "Unable to set freebie quantity to 1"
      );
    }


    document.dispatchEvent(
      new CustomEvent(
        "theme:cart:refresh"
      )
    );

  }

  async function waitForVariantInCart(
    variantId,
    shouldExist = true,
    attempts = 5,
    interval = 500
  ) {
    for (let i = 0; i < attempts; i++) {
      try {
        const cart = await getCurrentCart();

        const exists = cartHasVariant(cart, variantId);

        if (exists === shouldExist) {
          return cart;
        }

      } catch (error) {
        console.warn("Cart verification request failed:", error);
      }

      if (i < attempts - 1) {
        await wait(interval);
      }
    }

    throw new Error(
      `Cart verification failed for variant ${variantId}`
    );
  }

  function updateFreebieInstructionMessage(
    totalCartValue,
    selectedVariantId
  ) {
    const instructionMessage = document.querySelector(
      ".freebie_instruction__message"
    );

    if (!instructionMessage) return;

    const isEligible = totalCartValue >= freebieSet1CartValue;
    const hasSelectedFreebie = !!selectedVariantId;

    if (isEligible && !hasSelectedFreebie) {
      instructionMessage.style.display = "flex";
    } else {
      instructionMessage.style.display = "none";
    }
  }

  async function updateFreebieSet1State(totalCartValue, cart = null) {
    const isEligible = totalCartValue >= 799;

    const container = document.querySelector(".freebie_set1");

    if (!container) return;

    container.classList.toggle("is-eligible", isEligible);
    container.classList.toggle("is-disabled", !isEligible);

    const claimButtons = container.querySelectorAll(".claim-btn");

    // Always use cart as the source of truth
    if (!cart) {
      cart = await getCurrentCart();
    }

    const selectedFreebie = cart.items.find(item =>
      firstSetVariantIds.some(
        id => String(id) === String(item.variant_id)
      )
    );

    const selectedVariantId = selectedFreebie
      ? String(selectedFreebie.variant_id)
      : null;

    updateFreebieInstructionMessage(
      totalCartValue,
      selectedVariantId
    );

    const clearButton = container.querySelector(
      ".clear-selected-freebie"
    );

    if (clearButton) {
      clearButton.style.display =
        selectedVariantId ? "block" : "none";
    }

    claimButtons.forEach(button => {
      const variantId = button.getAttribute("data-variant-id");

      const isSelected =
        selectedVariantId &&
        String(selectedVariantId) === String(variantId);

      if (isSelected) {
        button.classList.add("claimed");
        button.classList.remove("disabled");
        button.setAttribute("disabled", "disabled");

        const btnText = button.querySelector(".btn__text");

        if (btnText) {
          btnText.textContent = "CLAIMED";
        }

        return;
      }

      // Not selected anymore
      button.classList.remove("claimed");

      const btnText = button.querySelector(".btn__text");

      if (btnText) {
        btnText.textContent = "CLAIM";
      }

      if (!isEligible) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
        return;
      }

      // If another freebie is selected,
      // don't allow another one to be claimed.
      if (
        selectedVariantId &&
        String(selectedVariantId) !== String(variantId)
      ) {
        button.classList.add("disabled");
        button.setAttribute("disabled", "disabled");
      } else {
        button.classList.remove("disabled");
        button.removeAttribute("disabled");
      }
    });
  }

  /*
   * Event delegation is used because the cart drawer
   * can re-render dynamically.
   */

  document.addEventListener(
    "click",
    async function (event) {

      const claimButton =
        event.target.closest(
          ".freebie_set1 .claim-btn"
        );


      if (!claimButton) {
        return;
      }


      const totalCartValue =
        getEligibleCartTotal();


      /*
       * Do not allow claim below ₹799
       */

      if (
        totalCartValue <
        freebieSet1CartValue
      ) {

        event.preventDefault();
        event.stopPropagation();

        return;

      }


      /*
       * Prevent double click
       */

      if (
        window._isFreebieUpdating ||
        claimButton.dataset.processing ===
        "true"
      ) {

        event.preventDefault();
        event.stopPropagation();

        return;

      }


      const selectedVariantId =
        claimButton.getAttribute(
          "data-variant-id"
        );


      if (!selectedVariantId) {
        return;
      }


      claimButton.dataset.processing =
        "true";


      /*
       * Disable all claim buttons
       */

      // document
      //   .querySelectorAll(
      //     ".freebie_set1 .claim-btn"
      //   )
      //   .forEach(button => {

      //     button.style.pointerEvents =
      //       "none";

      //     button.classList.add(
      //       "disabled"
      //     );

      //   });


      try {

        window._isFreebieUpdating =
          true;

        checkoutButton?.classList.add(
          "disabled_checkout"
        );


        const cart =
          await getCurrentCart();


        /*
         * Remove any OTHER set1 freebie.
         */

        const existingSet1Items =
          getSet1ItemsInCart(cart);


        for (
          const item of existingSet1Items
        ) {

          if (
            String(item.variant_id) !==
            String(selectedVariantId)
          ) {

            await deleteFromCart(
              item.variant_id
            );

            await wait(300);

          }

        }


        /*
         * Add selected freebie
         */

        const latestCart =
          await getCurrentCart();


        if (
          !cartHasVariant(
            latestCart,
            selectedVariantId
          )
        ) {

          await addToCart(
            selectedVariantId
          );

        } else {

          await setLineItemQtyToOne(
            selectedVariantId
          );

        }


        /*
         * Confirm it really exists
         */

        await waitForVariantInCart(
          selectedVariantId,
          true
        );


        /*
         * Refresh cart drawer
         */

        document.dispatchEvent(
          new CustomEvent(
            "theme:cart:refresh"
          )
        );


      } catch (error) {

        console.error(
          "Set 1 freebie claim error:",
          error
        );

      } finally {

        claimButton.dataset.processing =
          "false";

        window._isFreebieUpdating =
          false;

        window._isCartUpdating =
          false;


        /*
         * Re-run complete offer logic
         */

        setTimeout(
          () => {
            freebieAddToCart();
          },
          400
        );

      }

    }
  );

  function updateFreebieMessage(
    totalCartValue
  ) {

    const offerMessageFree =
      document.querySelector(
        ".autofreebie"
      );

    const offerMessageFreeSuccess =
      document.querySelector(
        ".autofreebie .offer-message__success-message"
      );

    const offerMessageFreeError =
      document.querySelector(
        ".autofreebie .offer-message__default-message"
      );

    if (!offerMessageFree) {
      return;
    }


    if (
      totalCartValue <
      firstSetCartValue
    ) {

      offerMessageFree.classList.remove(
        "is-success"
      );

      offerMessageFree.classList.add(
        "is-loading"
      );

      if (offerMessageFreeError) {

        offerMessageFreeError.textContent =
          `Shop for Rs. ${firstSetCartValue -
          totalCartValue
          } More For a Free Full Size Sunscreen!`;

      }

    }
    //  else if (
    //   totalCartValue <
    //   freebieSet1CartValue
    // ) {

    //   offerMessageFree.classList.add(
    //     "is-success"
    //   );
    //   offerMessageFree.classList.remove(
    //     "is-loading"
    //   );

    //   if (offerMessageFreeSuccess) {

    //     offerMessageFreeSuccess.innerHTML =
    //       "Yay! You Have Unlocked Mini Serum!" + "<br>" + `Shop for Rs. ${freebieSet1CartValue - totalCartValue} more For a Free Full Size Sunscreen!`;

    //   }

    // } 
    // else if (
    //   totalCartValue <
    //   secondSetCartValue
    // ) {

    //   offerMessageFree.classList.add(
    //     "is-success"
    //   );
    //   offerMessageFree.classList.remove(
    //     "is-loading"
    //   );

    //   if (offerMessageFreeSuccess) {

    //     offerMessageFreeSuccess.innerHTML =
    //       "Yay! You Have Unlocked Mini Serum + Full Size Pack" + "<br>" + `Shop for Rs. ${secondSetCartValue - totalCartValue} more For a Free Travel Pouch!.`;

    //   }

    // }
    else {

      offerMessageFree.classList.add(
        "is-success"
      );

      if (offerMessageFreeSuccess) {

        offerMessageFreeSuccess.textContent =
          "Yay! You Have Got Full Size Suncreen Free";

      }

    }

  }

  async function freebieAddToCart() {

    /*
     * Prevent multiple simultaneous executions
     */

    if (
      window._isFreebieLogicRunning
    ) {
      return;
    }


    window._isFreebieLogicRunning =
      true;


    /*
     * Disable checkout immediately.
     *
     * This prevents the user from checking out
     * while Shopify is processing freebies.
     */

    window._isFreebieUpdating =
      true;

    checkoutButton?.classList.add(
      "disabled_checkout"
    );


    try {

      /*
       * Get current cart
       */

      let cart =
        await getCurrentCart();


      /*
       * Get current eligible cart value
       */

      let totalCartValue =
        getEligibleCartTotal();


      console.log(
        "Freebie logic cart value:",
        totalCartValue
      );


      /* UPDATE FREEBIE SET 1 UI */

      updateFreebieSet1State(
        totalCartValue,
        cart
      );


      updateFreebieMessage(
        totalCartValue
      );


      /* TIER 1 - ₹499
         SECONDARY FREEBIE */

      if (
        totalCartValue >=
        firstSetCartValue
      ) {

        const secondaryExists =
          cartHasVariant(
            cart,
            freebieSecondaryVariantId
          );


        if (
          !secondaryExists &&
          freebieSecondaryVariantId
        ) {

          console.log(
            "₹499 reached -> Adding secondary freebie"
          );


          await addToCart(
            freebieSecondaryVariantId
          );


          /*
           * Shopify verification
           */

          cart =
            await waitForVariantInCart(
              freebieSecondaryVariantId,
              true
            );


        } else if (
          secondaryExists
        ) {

          /*
           * Make sure quantity is 1
           */

          await setLineItemQtyToOne(
            freebieSecondaryVariantId
          );

        }

      } else {

        /*
         * Below ₹499:
         * remove secondary freebie
         */

        const secondaryExists =
          cartHasVariant(
            cart,
            freebieSecondaryVariantId
          );


        if (
          secondaryExists &&
          freebieSecondaryVariantId
        ) {

          console.log(
            "Below ₹499 -> Removing secondary freebie"
          );


          await deleteFromCart(
            freebieSecondaryVariantId
          );


          await waitForVariantInCart(
            freebieSecondaryVariantId,
            false
          );


        }

      }


      /* GET FRESH CART AFTER TIER 1 */

      cart =
        await getCurrentCart();


      /*
       * IMPORTANT:
       *
       * The freebie itself must not change the eligible
       * cart value.
       *
       * Re-read the displayed eligible cart value after
       * the theme has had time to refresh.
       */

      await wait(300);

      totalCartValue =
        getEligibleCartTotal();


      /* TIER 2 - ₹799
         FREEBIE SET 1*/

      if (
        totalCartValue >=
        freebieSet1CartValue
      ) {

        /*
         * User is eligible to choose ONE.
         */

        updateFreebieSet1State(
          totalCartValue,
          cart
        );

      } else {

        /*
         * Below ₹799:
         * remove any previously claimed set1 freebie.
         */

        const set1Items =
          getSet1ItemsInCart(cart);


        if (set1Items.length) {

          console.log(
            "Below ₹799 -> Removing set1 freebie(s)"
          );


          for (
            const item of set1Items
          ) {

            await deleteFromCart(
              item.variant_id
            );

            await wait(250);

          }


          cart =
            await getCurrentCart();

        }


        updateFreebieSet1State(
          totalCartValue,
          cart
        );

      }


      /* TIER 3 - ₹999
         MAIN AUTOMATIC FREEBIE*/

      /*
       * Get latest cart before checking main freebie.
       */

      cart =
        await getCurrentCart();


      /*
       * Wait for drawer update so getEligibleCartTotal()
       * isn't based on stale markup.
       */

      await wait(300);


      totalCartValue =
        getEligibleCartTotal();


      const mainFreebieExists =
        cartHasVariant(
          cart,
          freebieVariantId
        );


      if (
        totalCartValue >=
        secondSetCartValue
      ) {

        if (
          !mainFreebieExists &&
          freebieVariantId
        ) {

          console.log(
            "₹999 reached -> Adding main freebie"
          );


          await addToCart(
            freebieVariantId
          );


          /*
           * VERY IMPORTANT:
           *
           * Do not enable checkout until Shopify
           * confirms the freebie.
           */

          cart =
            await waitForVariantInCart(
              freebieVariantId,
              true
            );


        } else if (
          mainFreebieExists
        ) {

          /*
           * Force quantity to 1
           */

          await setLineItemQtyToOne(
            freebieVariantId
          );

        }

      } else {

        /*
         * Below ₹999:
         * remove automatic main freebie.
         */

        if (
          mainFreebieExists &&
          freebieVariantId
        ) {

          console.log(
            "Below ₹999 -> Removing main freebie"
          );


          await deleteFromCart(
            freebieVariantId
          );


          await waitForVariantInCart(
            freebieVariantId,
            false
          );

        }

      }


      /* FINAL CART VERIFICATION*/

      await ensureOnlyOneSet1Freebie();

      await wait(300);


      const finalCart =
        await getCurrentCart();


      /*
       * Final eligible value
       */

      const finalTotalCartValue =
        getEligibleCartTotal();


      /*
       * Required freebie states
       */

      const secondaryRequired =
        finalTotalCartValue >=
        firstSetCartValue;


      const mainFreebieRequired =
        finalTotalCartValue >=
        secondSetCartValue;


      const finalSecondaryExists =
        cartHasVariant(
          finalCart,
          freebieSecondaryVariantId
        );


      const finalMainFreebieExists =
        cartHasVariant(
          finalCart,
          freebieVariantId
        );


      console.log(
        "FINAL FREEBIE CHECK:",
        {
          finalTotalCartValue,
          secondaryRequired,
          finalSecondaryExists,
          mainFreebieRequired,
          finalMainFreebieExists
        }
      );


      /*
       * ₹499 requirement failed
       */

      // if (
      //   secondaryRequired &&
      //   !finalSecondaryExists
      // ) {

      //   console.warn(
      //     "Secondary freebie not confirmed. Checkout remains disabled."
      //   );


      //   window._isFreebieUpdating =
      //     true;

      //   validateCheckoutState();

      //   return;

      // }


      /*
       * ₹999 requirement failed
       */

      if (
        mainFreebieRequired &&
        !finalMainFreebieExists
      ) {

        console.warn(
          "Main freebie not confirmed. Checkout remains disabled."
        );


        window._isFreebieUpdating =
          true;

        validateCheckoutState();

        return;

      }


      /*
       * Everything required is confirmed.
       */

      window._isFreebieUpdating =
        false;

      window._isCartUpdating =
        false;


      validateCheckoutState();

      updateCartProgress();


    } catch (error) {

      console.error(
        "Freebie logic error:",
        error
      );


      /*
       * SAFETY:
       *
       * If there is any error, checkout remains disabled.
       */

      window._isFreebieUpdating =
        true;

      window._isCartUpdating =
        false;

      validateCheckoutState();

    } finally {

      window._isFreebieLogicRunning =
        false;

    }

  }


  /* CHECKOUT VALIDATION */

  window.validateCheckoutState =
    async function validateCheckoutState() {

      const button =
        document.querySelector(
          ".cart__checkout"
        );


      if (!button) {
        return;
      }


      /*
       * Never enable checkout while
       * cart/freebie operations are happening.
       */

      if (
        window._isCartUpdating ||
        window._isFreebieUpdating
      ) {

        button.classList.add(
          "disabled_checkout"
        );

        return;

      }


      try {

        const cart =
          await getCurrentCart();


        /*
         * Main cart products
         */

        const mainItems =
          cart.items.filter(
            item =>
              !item.properties?.["_freebie"] &&
              !item.properties?.["freebie"]
          );


        /*
         * Existing DOM class is also checked because
         * your theme marks normal products with .false.
         */

        const mainItemsCount =
          document.querySelectorAll(
            ".cart__item.false"
          ).length;


        if (
          mainItemsCount <= 0 &&
          mainItems.length <= 0
        ) {

          button.classList.add(
            "disabled_checkout"
          );

          return;

        }


        const totalCartValue =
          getEligibleCartTotal();


        /* SECONDARY FREEBIE */

        // const secondaryRequired =
        //   totalCartValue >=
        //   firstSetCartValue;


        // const secondaryExists =
        //   cartHasVariant(
        //     cart,
        //     freebieSecondaryVariantId
        //   );


        // if (
        //   secondaryRequired &&
        //   !secondaryExists
        // ) {

        //   button.classList.add(
        //     "disabled_checkout"
        //   );

        //   return;

        // }


        /* MAIN FREEBIE */

        const mainFreebieRequired =
          totalCartValue >=
          secondSetCartValue;


        const mainFreebieExists =
          cartHasVariant(
            cart,
            freebieVariantId
          );


        if (
          mainFreebieRequired &&
          !mainFreebieExists
        ) {

          button.classList.add(
            "disabled_checkout"
          );

          return;

        }


        /*
         * ₹799 set1 is OPTIONAL.
         *
         * Customer is allowed to checkout without
         * selecting it because the requirement says
         * "should be able to select".
         *
         * If you want selection to be mandatory,
         * this is the only section that needs changing.
         */


        button.classList.remove(
          "disabled_checkout"
        );


      } catch (error) {

        console.error(
          "Checkout validation error:",
          error
        );


        /*
         * Fail-safe:
         * never enable checkout when verification fails.
         */

        button.classList.add(
          "disabled_checkout"
        );

      }

    };


  /* CART PROGRESS UPDATE */

  function updateCartProgress() {
    const wrapper = document.querySelector(".cart_progress__bar_wrapper");
    const fill = document.querySelector(".cart_progress__fill");

    if (!wrapper || !fill) {
      return;
    }

    const steps = Array.from(
      wrapper.querySelectorAll(".cart_progress__steps .step")
    );

    if (!steps.length) {
      return;
    }

    const thresholds = steps.map(step =>
      parseFloat(step.dataset.value || 0)
    );

    const cartTotal = getEligibleCartTotal();

    const stepCount = thresholds.length;
    const sectionSize = 100 / stepCount;

    let progress = 0;

    /*
     * Before first threshold
     * ₹0 → ₹499
     */
    if (cartTotal < thresholds[0]) {
      const range = thresholds[0];

      progress =
        (cartTotal / range) * sectionSize;
    }

    /*
     * Between first and second threshold
     * ₹499 → ₹799
     */
    else if (cartTotal < thresholds[1]) {
      const range =
        thresholds[1] - thresholds[0];

      const currentValue =
        cartTotal - thresholds[0];

      progress =
        sectionSize +
        (currentValue / range) * sectionSize;
    }

    /*
     * Between second and third threshold
     * ₹799 → ₹999
     */
    else if (cartTotal < thresholds[2]) {
      const range =
        thresholds[2] - thresholds[1];

      const currentValue =
        cartTotal - thresholds[1];

      progress =
        (sectionSize * 2) +
        (currentValue / range) * sectionSize;
    }

    /*
     * ₹999 and above
     */
    else {
      progress = 100;
    }

    fill.style.width = `${Math.min(progress, 100)}%`;

    /*
     * Active states
     */
    steps.forEach((step, index) => {
      const threshold = thresholds[index];

      if (cartTotal >= threshold) {
        step.classList.add("active");
      } else {
        step.classList.remove("active");
      }
    });
  }


  /* CART MUTATION OBSERVER */

  const cartItemsHolder =
    document.querySelector(
      "[data-items-holder]"
    );


  if (cartItemsHolder) {

    let freebieDebounceTimer = null;


    const runFreebieLogicDebounced =
      () => {

        clearTimeout(
          freebieDebounceTimer
        );


        freebieDebounceTimer =
          setTimeout(
            () => {

              freebieAddToCart();

            },
            700
          );

      };


    const observer =
      new MutationObserver(
        function () {

          /*
           * Any cart DOM change means
           * checkout should temporarily remain disabled.
           */

          window._isCartUpdating =
            true;


          checkoutButton?.classList.add(
            "disabled_checkout"
          );


          updateCartProgress();


          runFreebieLogicDebounced();

          setTimeout(() => {

            if (
              !window._isFreebieUpdating &&
              !window._isFreebieLogicRunning
            ) {

              ensureOnlyOneSet1Freebie();

            }

          }, 1000);

        }
      );


    observer.observe(
      cartItemsHolder,
      {
        childList: true,
        subtree: true
      }
    );


    /*
     * Initial execution
     */

    freebieAddToCart();

    updateCartProgress();


    setTimeout(
      () => {
        validateCheckoutState();
      },
      500
    );

  }


  document.addEventListener("click", async function (event) {
    const clearButton = event.target.closest(".clear-selected-freebie");

    if (!clearButton) return;

    event.preventDefault();
    event.stopPropagation();

    if (
      window._isFreebieUpdating ||
      clearButton.dataset.processing === "true"
    ) {
      return;
    }

    clearButton.dataset.processing = "true";

    try {
      window._isFreebieUpdating = true;
      checkoutButton?.classList.add("disabled_checkout");

      const cart = await getCurrentCart();

      // Find the currently selected ₹799 freebie
      const selectedFreebie = cart.items.find(item =>
        firstSetVariantIds.some(
          id => String(id) === String(item.variant_id)
        )
      );

      // Nothing selected
      if (!selectedFreebie) {
        clearButton.style.display = "none";
        return;
      }

      const variantId = selectedFreebie.variant_id;

      await deleteFromCart(variantId);

      await waitForVariantInCart(variantId, false);

      // Refresh cart UI
      document.dispatchEvent(
        new CustomEvent("theme:cart:refresh")
      );

      // Hide CLEAR button
      clearButton.style.display = "none";

      // Update claim buttons from the actual cart
      const updatedCart = await getCurrentCart();
      const updatedCartValue = getEligibleCartTotal();

      updateFreebieSet1State(updatedCartValue, updatedCart);

      setTimeout(() => {
        window._isFreebieUpdating = false;
        window._isCartUpdating = false;

        validateCheckoutState();
        updateCartProgress();
      }, 400);

    } catch (error) {
      console.error("Clear selected freebie error:", error);

      window._isFreebieUpdating = true;
      validateCheckoutState();

    } finally {
      clearButton.dataset.processing = "false";
    }
  });

  /* CART DRAWER OBSERVER */

  function observeCartUpdates() {

    const cartDrawer =
      document.querySelector(
        ".drawer--cart"
      );


    if (!cartDrawer) {
      return;
    }


    const observer =
      new MutationObserver(
        function (mutationsList) {

          for (
            const mutation
            of mutationsList
          ) {

            if (
              mutation.type ===
              "attributes" &&
              mutation.attributeName ===
              "class"
            ) {

              if (
                cartDrawer.classList.contains(
                  "is-open"
                )
              ) {

                setTimeout(
                  () => {

                    validateCheckoutState();

                  },
                  200
                );


                const freebieProduct =
                  document.querySelector(
                    ".cart__item.freeItem"
                  );


                const cartNudge =
                  document.querySelector(
                    ".autofreebie"
                  );


                if (
                  freebieProduct &&
                  cartNudge instanceof Element
                ) {

                  waitForClass(
                    cartNudge,
                    "is-loading",
                    () => {

                      cartNudge.classList.remove(
                        "is-loading"
                      );

                      cartNudge.classList.add(
                        "is-success"
                      );

                    }
                  );

                }


                /*
                 * Refresh Flickity if present
                 */

                const upsellCarousel =
                  document.querySelector(
                    ".upsell-products"
                  );


                if (
                  upsellCarousel &&
                  typeof Flickity !==
                  "undefined"
                ) {

                  const flktyInstance =
                    Flickity.data(
                      upsellCarousel
                    );


                  if (flktyInstance) {

                    flktyInstance.reloadCells();
                    flktyInstance.resize();

                  }

                }

              }

            }

          }


          updateDiscountButtonsBasedOnCart();

          /*
           * Do not directly enable checkout here.
           *
           * Full freebie validation is responsible
           * for enabling checkout.
           */

          validateCheckoutState();


          /*
           * Update freebie_set1 buttons
           */

          const currentCartValue =
            getEligibleCartTotal();


          getCurrentCart().then(cart => {
            updateFreebieSet1State(
              currentCartValue,
              cart
            );
          });

          setTimeout(() => {
            updateClaimedFreebieState();
          }, 300);

        }
      );


    observer.observe(
      cartDrawer,
      {
        attributes: true
      }
    );

  }


  observeCartUpdates();


  /* DISABLE ALL CLAIM BUTTONS ON INITIAL LOAD */

  // document
  //   .querySelectorAll(
  //     ".freebie_set1 .claim-btn"
  //   )
  //   .forEach(button => {

  //     button.style.pointerEvents =
  //       "none";

  //   });


  /* DISCOUNT FUNCTIONS */

  function updateDiscountButtonsBasedOnCart() {

    const subtotalEl =
      document.querySelector(
        ".cart__total__price--final"
      );


    if (!subtotalEl) {
      return;
    }


    updateCartSavings();


    const discountInput =
      document.querySelector(
        ".discount-input"
      );


    const discountInputValue =
      discountInput?.value || "";


    const cartSubtotal =
      parseFloat(
        subtotalEl.getAttribute(
          "data-cart-total"
        )
      ) || 0;


    document
      .querySelectorAll(
        ".discount-card-apply"
      )
      .forEach(button => {

        const threshold =
          parseFloat(
            button.getAttribute(
              "data-threshold"
            )
          ) || 0;


        const parentCard =
          button.closest(
            ".discount-card"
          );


        if (!parentCard) {
          return;
        }


        if (
          cartSubtotal >=
          threshold
        ) {

          if (
            !parentCard.classList.contains(
              "is-applied"
            )
          ) {

            button.classList.remove(
              "disabled"
            );

            button.removeAttribute(
              "disabled"
            );

            button.textContent =
              "Apply";

            localStorage.removeItem(
              "appliedDiscount"
            );

          }

        } else {

          if (
            parentCard.classList.contains(
              "is-applied"
            )
          ) {

            parentCard.classList.remove(
              "is-applied"
            );

            button.textContent =
              "Apply";

            localStorage.removeItem(
              "appliedDiscount"
            );


            const discountMsg =
              document.querySelector(
                ".discount-msg"
              );


            if (discountMsg) {

              discountMsg.textContent =
                "";

              discountMsg.classList.remove(
                "is-success",
                "is-error"
              );

            }


            if (discountInput) {
              discountInput.value =
                "";
            }

          }


          button.classList.add(
            "disabled"
          );

          button.setAttribute(
            "disabled",
            "disabled"
          );

        }

      });

  }


  /*
   * updateCartSavings may exist elsewhere
   * in the theme.
   */

  if (
    typeof updateCartSavings ===
    "function"
  ) {

    updateCartSavings();

  }

  updateDiscountButtonsBasedOnCart();

  const subtotalEl =
    document.querySelector(
      ".cart__total__price--final"
    );


  if (subtotalEl) {

    const subtotalObserver =
      new MutationObserver(
        () => {

          setTimeout(
            updateDiscountButtonsBasedOnCart,
            200
          );

        }
      );


    subtotalObserver.observe(
      subtotalEl,
      {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      }
    );

  }

  document
    .querySelectorAll(
      ".discount-card-apply"
    )
    .forEach(button => {

      button.addEventListener(
        "click",
        function () {

          const discountCode =
            button.getAttribute(
              "data-discount-code"
            );


          if (!discountCode) {
            return;
          }


          checkDiscountCode(
            discountCode
          );

        }
      );

    });

  const discountApply =
    document.querySelector(
      ".discount-apply"
    );


  if (discountApply) {

    discountApply.addEventListener(
      "click",
      function () {

        const discountInput =
          document.querySelector(
            ".discount-input"
          );


        const discountCode =
          discountInput?.value.trim();


        if (discountCode) {

          checkDiscountCode(
            discountCode
          );

        }

      }
    );

  }

  function applyDiscountViaIframe(
    code,
    onComplete
  ) {

    const iframe =
      document.createElement(
        "iframe"
      );


    iframe.style.display =
      "none";


    iframe.src =
      `/discount/${encodeURIComponent(
        code
      )}?v=${Date.now()}`;


    let completed =
      false;


    const complete =
      () => {

        if (completed) {
          return;
        }


        completed = true;


        iframe.remove();


        onComplete();

      };


    const timeoutFallback =
      setTimeout(
        complete,
        500
      );


    iframe.onload =
      () => {

        clearTimeout(
          timeoutFallback
        );

        complete();

      };


    document.body.appendChild(
      iframe
    );

  }

  function checkDiscountCode(
    code
  ) {

    const discountLoader =
      document.querySelector(
        ".discount-loader"
      );


    if (discountLoader) {

      discountLoader.style.display =
        "flex";

    }


    const drawerMain =
      document.querySelector(
        ".cart_drawer"
      );


    if (!drawerMain) {

      showInvalidMsg();

      return;

    }


    const section_id =
      drawerMain.getAttribute(
        "data-section-id"
      );


    applyDiscountViaIframe(
      code,
      () => {

        setTimeout(
          () => {

            fetch("/cart.js")
              .then(
                res => {

                  if (!res.ok) {
                    throw new Error(
                      "Unable to fetch cart"
                    );
                  }

                  return res.json();

                }
              )
              .then(
                updatedCart => {

                  const applied =
                    updatedCart.discount_codes.find(
                      dc =>
                        dc.code.toLowerCase() ===
                        code.toLowerCase()
                    );


                  if (
                    applied &&
                    applied.applicable
                  ) {

                    const discountMsg =
                      document.querySelector(
                        ".discount-msg"
                      );


                    if (discountMsg) {

                      discountMsg.textContent =
                        "Coupon successfully applied";

                      discountMsg.classList.remove(
                        "is-error"
                      );

                      discountMsg.classList.add(
                        "is-success"
                      );

                    }


                    const discountInput =
                      document.querySelector(
                        ".discount-input"
                      );


                    if (discountInput) {

                      discountInput.value =
                        code;

                    }


                    const discountApply =
                      document.querySelector(
                        ".discount-apply"
                      );


                    if (discountApply) {

                      discountApply.style.display =
                        "block";

                    }


                    localStorage.setItem(
                      "appliedDiscount",
                      code
                    );


                    /*
                     * Refresh cart price section
                     */

                    if (section_id) {

                      fetch(
                        `/?section_id=${section_id}`
                      )
                        .then(
                          res =>
                            res.text()
                        )
                        .then(
                          html => {

                            const parser =
                              new DOMParser();


                            const newDoc =
                              parser.parseFromString(
                                html,
                                "text/html"
                              );


                            const newCartSummary =
                              newDoc.querySelector(
                                ".cart-price-wrapper"
                              );


                            const currentCartSummary =
                              document.querySelector(
                                ".cart-price-wrapper"
                              );


                            if (
                              newCartSummary &&
                              currentCartSummary
                            ) {

                              currentCartSummary.innerHTML =
                                newCartSummary.innerHTML;

                            }

                          }
                        )
                        .catch(
                          error =>
                            console.error(
                              "Cart summary refresh error:",
                              error
                            )
                        );

                    }


                    /*
                     * Reset discount cards
                     */

                    document
                      .querySelectorAll(
                        ".discount-card"
                      )
                      .forEach(card => {

                        card.classList.remove(
                          "is-applied"
                        );


                        const applyBtn =
                          card.querySelector(
                            ".discount-card-apply"
                          );


                        if (applyBtn) {

                          applyBtn.textContent =
                            "Apply";

                          applyBtn.removeAttribute(
                            "disabled"
                          );

                        }

                      });


                    const appliedCard =
                      document.querySelector(
                        `.discount-card[data-discount-code="${CSS.escape(
                          code
                        )}"]`
                      );


                    if (appliedCard) {

                      appliedCard.classList.add(
                        "is-applied"
                      );


                      const applyBtn =
                        appliedCard.querySelector(
                          ".discount-card-apply"
                        );


                      if (applyBtn) {

                        applyBtn.textContent =
                          "Applied";

                        applyBtn.setAttribute(
                          "disabled",
                          "disabled"
                        );

                      }

                    }


                  } else {

                    showInvalidMsg();

                  }


                  if (discountLoader) {

                    discountLoader.style.display =
                      "none";

                  }

                }
              )
              .catch(
                error => {

                  console.error(
                    "Discount validation error:",
                    error
                  );

                  showInvalidMsg();

                }
              );

          },
          600
        );

      }
    );


    function showInvalidMsg() {

      const discountMsg =
        document.querySelector(
          ".discount-msg"
        );


      if (discountMsg) {

        discountMsg.textContent =
          "Coupon cannot be applied";

        discountMsg.classList.remove(
          "is-success"
        );

        discountMsg.classList.add(
          "is-error"
        );

      }


      if (discountLoader) {

        discountLoader.style.display =
          "none";

      }


      setTimeout(
        () => {

          if (discountMsg) {

            discountMsg.classList.remove(
              "is-error"
            );

            discountMsg.textContent =
              "";

          }


          const discountInput =
            document.querySelector(
              ".discount-input"
            );


          if (discountInput) {

            discountInput.value =
              "";

          }

        },
        2000
      );

    }

  }

});

// custom code to close all other open accordions when one is opened
document.addEventListener('click', function (e) {
  if (e.target.closest('summary')) {
    const clickedDetail = e.target.closest('details');
    document.querySelectorAll('details.accordion').forEach((detail) => {
      if (detail !== clickedDetail) detail.removeAttribute('open');
    });
  }
});

// custom code to subscribe to newsletter
const newslettersubmitButton = document.querySelector(".subscribeNewsletter");
if (newslettersubmitButton) {
  newslettersubmitButton.addEventListener("click", function (event) {
    event.preventDefault();
    const emailInput = newslettersubmitButton.parentElement.querySelector(".newsletter-email");
    const newsletterForm = document.querySelector('.newsletter-form');
    const email = emailInput.value;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      document.querySelector('.newsletter-response-wrapper').style.display = 'block';
      document.getElementById("response-message").innerText = "Please enter a valid email address.";
      document.getElementById("response-message").classList.add("is-error");
      return;
    }
    else {
      if (document.getElementById("newsletterConsent").checked) {
        // subscribeEmail(email);
        newsletterForm.submit();
      } else {
        document.querySelector('.newsletter-response-wrapper').style.display = 'block';
        document.getElementById("response-message").innerText = "Please check the consent box to subscribe.";
        document.getElementById("response-message").classList.add("is-error");
      }
    }
  });
}

function subscribeEmail(email) {
  fetch("https://apis.novology.com/novo-dev/updateCustomermarketingStatus.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: `email=${encodeURIComponent(email)}`
  })
    .then(response => response.json())
    .then(data => {
      document.querySelector('.newsletter-response-wrapper').style.display = 'block';
      document.querySelector('.form-fields').style.display = 'none';
      document.querySelector('.newsletter-consent').style.display = 'none';
      document.getElementById("response-message").innerText = data.message;
    })
    .catch(error => {
      console.error(error);
      document.querySelector('.newsletter-response-wrapper').style.display = 'block';
      document.querySelector('.form-fields').style.display = 'none';
      document.querySelector('.newsletter-consent').style.display = 'none';
      document.getElementById("response-message").innerText = "An error occurred.";
    });
}

function storeCurrentPageAndRedirectLogin() {
  localStorage.setItem("previousPage", window.location.pathname);
  window.location.href = "/account";
}


document.addEventListener("DOMContentLoaded", function () {
  if (localStorage.getItem("reopenCartDrawer") === "true") {
    localStorage.removeItem("reopenCartDrawer");
    const cartDrawer = document.querySelector('.navlink--cart--icon');
    cartDrawer.click();
  }
});

//To add active class to tabs in plp
document.addEventListener("DOMContentLoaded", function () {
  const currentPath = window.location.pathname.replace(/\/+$/, ""); // remove trailing slash
  const menuItems = document.querySelectorAll(".plp_menu");

  menuItems.forEach(item => {
    const itemUrl = item.getAttribute("data-collection-url");

    // Normalize both for safe comparison
    if (itemUrl && itemUrl.replace(/\/+$/, "") === currentPath) {
      item.classList.add("active");

      // Optional: update data-collection-name to match new state
      const matchedMenuColor = item.className.split(" ").pop(); // assumes color is last class
      item.setAttribute("data-collection-name", matchedMenuColor);
    }
  });
});

// document.addEventListener('DOMContentLoaded', () => {
//   setupDelegatedCartDrawerEvents();

//   loadUpsellInDrawer();
// });

// function loadUpsellInDrawer() {
//   const cartDrawer = document.querySelector('.cart_drawer');
//   const sectionId = cartDrawer?.getAttribute('data-section-id');

//   if (!sectionId) return;

//   fetch(`/?section_id=${sectionId}`)
//     .then((res) => res.text())
//     .then((html) => {
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(html, 'text/html');
//       const newUpsell = doc.querySelector('.upsell-prouduct-wrapper');

//       if (!newUpsell) return;

//       const existingUpsell = document.querySelector('.upsell-prouduct-wrapper');
//       if (existingUpsell) {
//         existingUpsell.replaceWith(newUpsell);
//       } else {
//         cartDrawer.append(newUpsell);
//       }

//       const carousel = newUpsell.querySelector('.upsell-products.carousel');
//       if (carousel) {
//         new Flickity(carousel, {
//           adaptiveHeight: true,
//           contain: true,
//           wrapAround: false,
//           groupCells: 1,
//           prevNextButtons: false,
//           freeScroll: false,
//         });
//       }
//     });
// }

// function setupDelegatedCartDrawerEvents() {
//   document.querySelector('.cart_drawer')?.addEventListener('click', (e) => {
//     if (e.target.closest('.add-to-cart-btn')) {
//       const btn = e.target.closest('.add-to-cart-btn');
//       e.preventDefault();
//     }

//     if (e.target.closest('.increase-cart-qty')) {
//       const btn = e.target.closest('.increase-cart-qty');
//       e.preventDefault();
//     }

//     if (e.target.closest('.decrease-cart-qty')) {
//       const btn = e.target.closest('.decrease-cart-qty');
//       e.preventDefault();
//     }
//   });
// }
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("view-cart-button");

  if (!btn) return;

  btn.addEventListener("click", (e) => {
    const cartDrawer = document.querySelector("cart-drawer"); // your cart drawer element

    if (cartDrawer) {
      e.preventDefault();
      cartDrawer.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
      window.a11y.lastElement = btn;
    }
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const variantDataEl = document.getElementById("variant-data");
  if (!variantDataEl) return;

  const variants = JSON.parse(variantDataEl.textContent);

  function formatMoney(cents) {
    return Shopify.formatMoney(cents, "{{ shop.money_format }}");
  }

  function updateDetails(variant) {
    if (!variant) return;

    // 🔹 Net Volume = first option (Size / Volume)
    document.getElementById("netVolume").textContent =
      variant.options?.[0] || "-";

    // 🔹 Unit Sale Price = variant.price
    document.getElementById("unitSalePrice").textContent =
      formatMoney(variant.price);

    // 🔹 MRP = compare_at_price OR price
    document.getElementById("mrp").textContent =
      formatMoney(variant.compare_at_price || variant.price);
  }

  // Initial load
  updateDetails(variants.find(v => v.available));

  // Shopify variant change event
  document.addEventListener("variant:change", (e) => {
    updateDetails(e.detail.variant);
  });

  // Fallback for <select name="id">
  const variantSelect = document.querySelector('[name="id"]');
  if (variantSelect) {
    variantSelect.addEventListener("change", () => {
      const selectedVariant = variants.find(v => v.id == variantSelect.value);
      updateDetails(selectedVariant);
    });
  }
});

const Mobile = window.innerWidth <= 750;

const newFlickety = new Flickity('#spotlightCarousel', {
  freeScroll: false,
  wrapAround: true,
  contain: true,
  groupCells: 1,
  autoPlay: false,

  // 🎯 Responsive behavior
  prevNextButtons: !Mobile, // arrows only on desktop
  pageDots: Mobile          // dots only on mobile
});

function initCarousel() {
  const yesMobile = window.innerWidth <= 750;

  return new Flickity('#spotlightCarousel', {
    freeScroll: false,
    wrapAround: true,
    contain: true,
    groupCells: 1,
    autoPlay: false,
    prevNextButtons: !yesMobile,
    pageDots: yesMobile
  });
}

let newFlick = initCarousel();

window.addEventListener('resize', () => {
  // flkty.destroy();
  flkty = initCarousel();
});

const headerDrawer = document.querySelector('header-drawer');
const hamburgerMenu = document.querySelector('.header__mobile__hamburger');

document.addEventListener('click', (event) => {
  const openDrawer = document.querySelector('.drawer--header.is-open');

  if (!openDrawer) return;

  const drawerInner = openDrawer.querySelector('.drawer__inner');

  const clickedInsideDrawer = drawerInner.contains(event.target);
  const clickedHamburger = hamburgerMenu.contains(event.target);

  if (!clickedInsideDrawer && !clickedHamburger) {
    openDrawer.classList.remove('is-open');
    openDrawer.classList.remove('drawer--animated');

    // drawerInner.style.animation = 'none';

    console.log('Hamburger menu closed');
  }
});

const sidebarSlider = document.querySelector('.collection__sidebar__slider');
const mobileFilter = document.querySelector('.mobile-view.mobile-filter');

if (window.innerWidth < 768 && sidebarSlider) {
  document.addEventListener('click', (event) => {
    if (
      !sidebarSlider.contains(event.target) &&
      !mobileFilter?.contains(event.target)
    ) {
      sidebarSlider.classList.remove('expanded');
      sidebarSlider.classList.remove('drawer--animated');
      console.log('Search popdown closed');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const cartConsent = document.querySelector('.cart_consent__text');
  const cart = document.querySelector('.drawer--cart');

  if (!cartConsent || !cart) return;

  const isCartEmpty = cart.classList.contains('is-empty');

  cartConsent.classList.toggle('is-empty', isCartEmpty);
});

document.addEventListener("DOMContentLoaded", function () {
  const loginConsentPopup = document.querySelector(".login_consent__popup");
  const loginPopupOverlay = document.querySelector(".login_popup__overlay");

  if (!loginConsentPopup) return;

  const loginLinks = document.querySelectorAll(".mobile-login-link-Wrapper, .custom_login_button, .customer-icon-container");

  loginLinks.forEach(link => {
    link.addEventListener("click", function (e) {
      if (this.classList.contains("customer-icon-container") || this.closest(".customer-icon-container")) {
        e.preventDefault();
      }
      if (this.classList.contains("mobile-login-link-Wrapper") || this.closest(".mobile-login-link-Wrapper")) {
        document.querySelector(".mobile-menu .drawer--header")?.classList.remove("is-open");
        document.querySelector(".header__mobile__hamburger")?.setAttribute("aria-expanded", "false");
        unlockThemeScroll();
      }

      loginConsentPopup.classList.add("show_popup");
      if (loginPopupOverlay) loginPopupOverlay.classList.add("show_overlay");

      if (!window.loginPrefetched) {
        const prefetchLink = document.createElement("link");
        prefetchLink.rel = "prefetch";
        prefetchLink.as = "document";
        prefetchLink.href = "/account/login";
        document.head.appendChild(prefetchLink);
        window.loginPrefetched = true;
      }
    });
  });

  const closeLoginPopup = () => {
    loginConsentPopup.classList.remove("show_popup");
    if (loginPopupOverlay) loginPopupOverlay.classList.remove("show_overlay");
    sessionStorage.removeItem("loginConsentInProgress");
    unlockThemeScroll();
  };

  const closeBtn = document.querySelector(".close_popup");
  if (closeBtn) closeBtn.addEventListener("click", closeLoginPopup);
  if (loginPopupOverlay) loginPopupOverlay.addEventListener("click", closeLoginPopup);
});

document.getElementById("proceedLoginBtn")?.addEventListener("click", function (e) {
  // Prevent any global click listeners (Analytics, GTM, Theme scripts) from blocking navigation
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  sessionStorage.setItem("loginConsentInProgress", "true");
  sessionStorage.setItem("loginPreviousPage", window.location.pathname);

  storeCurrentPageAndRedirectLogin();

  // Update UI while waiting for server response
  const button = this;
  button.disabled = true;
  button.classList.add("loading");
  button.innerHTML = `
    <span class="button-spinner"></span>
    <span>Proceeding...</span>
  `;
});

window.addEventListener("pageshow", function () {
  const loginConsentPopup = document.querySelector(".login_consent__popup");
  const loginPopupOverlay = document.querySelector(".login_popup__overlay");

  const inProgress =
    sessionStorage.getItem("loginConsentInProgress") === "true";

  const previousPage = sessionStorage.getItem("loginPreviousPage");

  if (inProgress && previousPage === window.location.pathname) {
    loginConsentPopup?.classList.add("show_popup");
    loginPopupOverlay?.classList.add("show_overlay");
  } else {
    loginConsentPopup?.classList.remove("show_popup");
    loginPopupOverlay?.classList.remove("show_overlay");

    sessionStorage.removeItem("loginConsentInProgress");
    sessionStorage.removeItem("loginPreviousPage");
  }
});

function unlockThemeScroll() {
  document.dispatchEvent(
    new CustomEvent("theme:scroll:unlock", {
      bubbles: true,
    })
  );
}

document.addEventListener("click", function (e) {
  const increaseBtn = e.target.closest(".increase-cart-qty");
  if (!increaseBtn) return;

  const quantityWrapper = increaseBtn.closest(".quantity-wrapper");
  const quantityEl = quantityWrapper.querySelector(".cart-quantity");
  const errorWrapper = quantityWrapper.parentElement.querySelector(".product-error-wrapper");
  const errorMessage = quantityWrapper.parentElement.querySelector(".product-error-message");

  const currentQty = parseInt(quantityEl.textContent, 10) || 0;
  const newQty = currentQty + 1;

  if (newQty > 5) {
    errorWrapper.style.display = "flex";
    errorMessage.textContent = "Limit reached! You can add up to 5 units only."
    setTimeout(() => {
      errorWrapper.style.display = "none";
      errorMessage.textContent = ""
    }, 2000);
  } else {
    errorWrapper.style.display = "none";
    errorMessage.textContent = ""
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const whatsappConsent = document.querySelector(".wa-consent-popup");
  const agreeBtn = document.getElementById("wa-agree-btn");
  const disagreeBtn = document.getElementById("wa-disagree-btn");

  let whatsappUrl = "";

  function bindWhatsappButton() {
    const whatsappButton = document.querySelector(".WhatsAppButton__root a");

    if (!whatsappButton) {
      // Try again after 300ms
      setTimeout(bindWhatsappButton, 300);
      return;
    }

    // Prevent attaching multiple listeners
    if (whatsappButton.dataset.listenerAttached) return;
    whatsappButton.dataset.listenerAttached = "true";

    whatsappButton.addEventListener("click", function (e) {
      e.preventDefault();

      whatsappUrl = this.href;
      whatsappConsent.classList.add("show");
    });
  }

  bindWhatsappButton();

  agreeBtn?.addEventListener("click", function () {
    whatsappConsent.classList.remove("show");

    if (whatsappUrl) {
      window.open(whatsappUrl, "_blank");
    }
  });

  disagreeBtn?.addEventListener("click", function () {
    whatsappConsent.classList.remove("show");
  });
});

document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".reviewcarousel").forEach((carousel) => {

    const updateVideos = () => {

      const videos = carousel.querySelectorAll("video");

      videos.forEach((video) => {

        const cell = video.closest(".splide__slide");

        if (!cell) return;

        const muteBtn = cell.querySelector(".mute");
        const unmuteBtn = cell.querySelector(".unmute");

        if (!muteBtn || !unmuteBtn) return;

        // Always start muted
        video.muted = true;

        muteBtn.style.display = "none";
        unmuteBtn.style.display = "block";

      });

    };


    // Initial state
    updateVideos();


    // ------------------------------------
    // Detect Splide active slide changes
    // ------------------------------------
    const mutationObserver = new MutationObserver((mutations) => {

      mutations.forEach((mutation) => {

        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {

          const cell = mutation.target;

          if (
            cell.classList.contains("splide__slide") &&
            cell.classList.contains("is-active")
          ) {

            updateVideos();

          }

        }

      });

    });


    // Observe all Splide slides
    carousel
      .querySelectorAll(".splide__slide")
      .forEach((slide) => {

        mutationObserver.observe(slide, {
          attributes: true,
          attributeFilter: ["class"]
        });

      });


    // ------------------------------------
    // Mute / Unmute
    // ------------------------------------
    carousel.addEventListener("click", (e) => {

      const icon = e.target.closest(".mute, .unmute");

      if (!icon) return;

      const cell = icon.closest(".splide__slide");

      if (!cell) return;


      // Only active slide can be unmuted
      if (!cell.classList.contains("is-active")) return;


      const video = cell.querySelector("video");

      const muteBtn = cell.querySelector(".mute");
      const unmuteBtn = cell.querySelector(".unmute");

      if (!video || !muteBtn || !unmuteBtn) return;


      // Toggle mute
      video.muted = !video.muted;


      if (video.muted) {

        muteBtn.style.display = "none";
        unmuteBtn.style.display = "block";

      } else {

        muteBtn.style.display = "block";
        unmuteBtn.style.display = "none";

      }

    });


    // ------------------------------------
    // Intersection Observer
    // ------------------------------------
    const observer = new IntersectionObserver(
      (entries) => {

        entries.forEach((entry) => {

          if (!entry.isIntersecting) {

            const video = entry.target;

            video.muted = true;

            const cell = video.closest(".splide__slide");

            if (!cell) return;

            const muteBtn = cell.querySelector(".mute");
            const unmuteBtn = cell.querySelector(".unmute");

            if (muteBtn) {
              muteBtn.style.display = "none";
            }

            if (unmuteBtn) {
              unmuteBtn.style.display = "block";
            }

          }

        });

      },
      {
        threshold: 0.5
      }
    );


    carousel
      .querySelectorAll("video")
      .forEach((video) => {

        observer.observe(video);

      });

  });

});

const removeFromFromReviews = () => {
  document.querySelectorAll(".opw-text-left.opw-fontLg.opw-textColor").forEach((el) => {
    el.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        node.textContent = node.textContent.replace(/^from\s*/i, "");
      }
    });
  });
};

// Check elements already on the page
removeFromFromReviews();

// Watch for dynamically injected content
const observer = new MutationObserver(() => {
  removeFromFromReviews();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

(function () {

  function updateUpsellQuantityStates() {

    const upsellSlider = document.querySelector(
      ".custom-upsell-product-slider"
    );

    if (!upsellSlider) return;

    fetch("/cart.js", {
      cache: "no-store"
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {

        const cartItems = cart.items || [];

        upsellSlider
          .querySelectorAll(".product-item")
          .forEach(function (productCard) {

            const sizeContainer =
              productCard.querySelector(".product-card-sizes");

            const quantityWrapper =
              productCard.querySelector(".quantity-wrapper");

            const atcButton =
              productCard.querySelector(".add-to-cart-btn");

            if (!quantityWrapper || !atcButton) return;

            let activeVariantId = null;

            if (sizeContainer) {

              const activeSwatch =
                sizeContainer.querySelector(".size-swatch.active");

              if (activeSwatch) {
                activeVariantId =
                  activeSwatch.getAttribute("data-variant-id");
              }
            }

            if (!activeVariantId) {
              activeVariantId =
                atcButton.getAttribute("data-variant-id");
            }

            if (!activeVariantId) return;

            activeVariantId = String(activeVariantId);

            const cartItem = cartItems.find(function (item) {
              return String(item.variant_id) === activeVariantId;
            });


            if (cartItem) {

              quantityWrapper.classList.add("active-qty");
              quantityWrapper.style.display = "";

              quantityWrapper.setAttribute(
                "data-variant-id",
                activeVariantId
              );

              quantityWrapper.setAttribute(
                "data-key",
                cartItem.key
              );

              const cartQuantity = quantityWrapper.querySelector(".cart-quantity");

              if (cartQuantity) {
                cartQuantity.textContent = cartItem.quantity;
              }

              const decreaseBtn = quantityWrapper.querySelector(
                ".decrease-cart-qty"
              );

              const increaseBtn = quantityWrapper.querySelector(
                ".increase-cart-qty"
              );

              if (decreaseBtn) {
                decreaseBtn.setAttribute("data-key", cartItem.key);
                decreaseBtn.setAttribute(
                  "data-variant-id",
                  activeVariantId
                );
              }

              if (increaseBtn) {
                increaseBtn.setAttribute("data-key", cartItem.key);
                increaseBtn.setAttribute(
                  "data-variant-id",
                  activeVariantId
                );

                // Disable + at 5
                increaseBtn.disabled = false;
              }

              atcButton.classList.add("hide-atc_btn");

            } else {

              quantityWrapper.classList.remove("active-qty");
              quantityWrapper.style.display = "none";

              quantityWrapper.removeAttribute("data-key");
              quantityWrapper.removeAttribute("data-variant-id");

              const increaseBtn = quantityWrapper.querySelector(
                ".increase-cart-qty"
              );

              if (increaseBtn) {
                increaseBtn.disabled = false;
              }

              atcButton.classList.remove("hide-atc_btn");
            }

          });

      })
      .catch(function (error) {
        console.error(
          "Upsell cart variant check failed:",
          error
        );
      });
  }

  document.addEventListener("click", function (event) {

    const increaseBtn = event.target.closest(
      ".custom-upsell-product-slider .increase-cart-qty"
    );

    const decreaseBtn = event.target.closest(
      ".custom-upsell-product-slider .decrease-cart-qty"
    );

    if (!increaseBtn && !decreaseBtn) return;

    const button = increaseBtn || decreaseBtn;

    const quantityWrapper = button.closest(".quantity-wrapper");

    if (!quantityWrapper) return;

    const key =
      button.getAttribute("data-key") ||
      quantityWrapper.getAttribute("data-key");

    if (!key) {
      console.warn("Upsell quantity: cart key not found");
      return;
    }

    const quantityElement =
      quantityWrapper.querySelector(".cart-quantity");

    const currentQuantity = parseInt(
      quantityElement?.textContent || "1",
      10
    );

    /*
    * STOP EVERYTHING AT QUANTITY 5
    */
    if (increaseBtn && currentQuantity >= 5) {
      return;
    }

    const newQuantity = increaseBtn
      ? currentQuantity + 1
      : Math.max(0, currentQuantity - 1);

    button.disabled = true;

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: key,
        quantity: newQuantity
      })
    })
      .then(function (response) {

        if (!response.ok) {
          throw new Error("Cart change failed");
        }

        return response.json();

      })
      .then(function () {

        document.dispatchEvent(
          new CustomEvent("theme:cart:refresh")
        );

        setTimeout(function () {
          updateUpsellQuantityStates();
        }, 150);

      })
      .catch(function (error) {

        console.error(
          "Upsell quantity update failed:",
          error
        );

      })
      .finally(function () {

        button.disabled = false;

      });

  });

  let timer;

  const observer = new MutationObserver(function () {

    clearTimeout(timer);

    timer = setTimeout(function () {
      updateUpsellQuantityStates();
    }, 150);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  updateUpsellQuantityStates();

  document.addEventListener(
    "theme:cart:refresh",
    function () {
      setTimeout(function () {
        updateUpsellQuantityStates();
      }, 200);
    }
  );

  document.addEventListener("click", function (event) {

    const swatch = event.target.closest(
      ".custom-upsell-product-slider .size-swatch"
    );

    if (!swatch) return;

    setTimeout(function () {
      updateUpsellQuantityStates();
    }, 50);

  });

})();

function updateCheckoutForFreebieOnlyCart() {
  fetch('/cart.js', {
    cache: 'no-store'
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      const checkoutButton = document.querySelector('.cart__checkout');

      if (!checkoutButton) return;

      const regularItems = cart.items.filter(function (item) {
        return !item.properties || item.properties._freebie !== 'true';
      });

      const hasOnlyFreebies =
        cart.items.length > 0 && regularItems.length === 0;

      if (hasOnlyFreebies) {
        checkoutButton.classList.add('disabled_checkout');
        checkoutButton.disabled = true;
      } else {
        checkoutButton.classList.remove('disabled_checkout');
        checkoutButton.disabled = false;
      }
    })
    .catch(function (error) {
      console.error('[Checkout] Error checking freebie-only cart:', error);
    });
}

document.addEventListener('theme:cart:refresh', function () {
  updateCheckoutForFreebieOnlyCart();
});

document.addEventListener('DOMContentLoaded', function () {
  updateCheckoutForFreebieOnlyCart();
});

document.addEventListener("DOMContentLoaded", function () {
  const announcementBar = document.querySelector(".section-announcement-bar");

  if (!announcementBar) return;

  function updateAnnouncementBar() {
    const height = announcementBar.offsetHeight;

    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      height + "px"
    );

    document.body.style.paddingTop = height + "px";
  }

  updateAnnouncementBar();
  window.addEventListener("resize", updateAnnouncementBar);

  if ("ResizeObserver" in window) {
    new ResizeObserver(updateAnnouncementBar).observe(announcementBar);
  }
});


// Buy Now functionality
(function() {
    const BUY_NOW_SELECTOR = '.custom-btn--buy-now';
    const overlay = document.getElementById('custom-gokwik-overlay');
    const AUTOMATIC_FREEBIE_THRESHOLD = 799;
    const FREEBIE_CHECK_DELAYS = [80, 120, 180];
    const RESTORE_WATCHDOG_INTERVAL = 50;
    let activeBuyNowButton = null;
    let buyNowRunning = false;
    let originalBuyNowCart = null;
    let buyNowCheckoutActive = false;
    let buyNowCartRestored = false;
    let isRestoringOriginalCart = false;
    let cancellationRestoreRunning = false;
    let cachedCart = null;
    let sdkPromise = null;
    let restoreQueued = false;
    let restoreWatchdog = null;
    let checkoutOpenedAt = 0;
    let checkoutReturnDetected = false;
    let gokwikOverlayObserver = null;
    let gokwikOverlayWasVisible = false;
    let gokwikOverlayClickTriggered = false;
    let lastDocumentVisibility = document.visibilityState;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function showOverlay() {
        if (overlay) {
            overlay.classList.add('is-active');
        }
    }

    function hideOverlay() {
        if (overlay) {
            overlay.classList.remove('is-active');
        }
    }

    function isElementVisible(element) {
        if (!element || !element.isConnected) {
            return false;
        }
        const style = window.getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
            return false;
        }
        const rect = element.getBoundingClientRect();
        return (rect.width > 0 && rect.height > 0);
    }

    function findGoKwikOverlay() {
        const selectors = ['[id*="gokwik" i]', '[class*="gokwik" i]', '[id*="go-kwik" i]', '[class*="go-kwik" i]'];
        const elements = document.querySelectorAll(selectors.join(','));
        let bestMatch = null;
        elements.forEach(element => {
            if (!isElementVisible(element)) {
                return;
            }
            if (element.id === 'custom-gokwik-overlay') {
                return;
            }
            const rect = element.getBoundingClientRect();
            const style = window.getComputedStyle(element);
            const isOverlayPosition = style.position === 'fixed' || style.position === 'absolute';
            const coversLargeArea = rect.width >= window.innerWidth * 0.5 || rect.height >= window.innerHeight * 0.5;
            if (isOverlayPosition && coversLargeArea) {
                bestMatch = element;
            }
        });
        return bestMatch;
    }

    function initiateGoKwikOverlayClick(overlayElement) {
        if (!overlayElement || gokwikOverlayClickTriggered) {
            return;
        }
        if (!buyNowCheckoutActive || buyNowCartRestored || isRestoringOriginalCart) {
            return;
        }
        gokwikOverlayClickTriggered = true;
        console.log('[Custom Buy Now] GoKwik overlay detected. Initiating overlay click.');
        try {
            overlayElement.dispatchEvent(new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            }));
        } catch (error) {
            console.warn('[Custom Buy Now] Unable to dispatch GoKwik overlay click:', error);
        }
        restoreAfterBuyNowCancellation();
    }

    function stopGoKwikOverlayObserver() {
        if (gokwikOverlayObserver) {
            gokwikOverlayObserver.disconnect();
            gokwikOverlayObserver = null;
        }
        gokwikOverlayWasVisible = false;
    }

    function checkGoKwikOverlay() {
        if (!buyNowCheckoutActive || buyNowCartRestored || !originalBuyNowCart) {
            return;
        }
        if (performance.now() - checkoutOpenedAt < 500) {
            return;
        }
        const gokwikOverlay = findGoKwikOverlay();
        const isVisible = !!gokwikOverlay;
        if (isVisible && !gokwikOverlayWasVisible) {
            console.log('[Custom Buy Now] GoKwik overlay became visible.');
            initiateGoKwikOverlayClick(gokwikOverlay);
        }
        gokwikOverlayWasVisible = isVisible;
    }

    function startGoKwikOverlayObserver() {
        stopGoKwikOverlayObserver();
        gokwikOverlayWasVisible = false;
        gokwikOverlayClickTriggered = false;
        /*
         * Check immediately.
         */
        checkGoKwikOverlay();
        gokwikOverlayObserver = new MutationObserver(function() {
            checkGoKwikOverlay();
        });
        if (document.body) {
            gokwikOverlayObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'aria-hidden', 'hidden']
            });
        }
    }

    function getVariantId(button) {
        if (!button) {
            return null;
        }
        const form = button.closest('form[action*="/cart/add"]');
        if (form) {
            const selectedOption = form.querySelector('input[type="radio"][data-single-option-selector]:checked[data-variant-id]');
            if (selectedOption && selectedOption.dataset.variantId) {
                return String(selectedOption.dataset.variantId);
            }
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
                return String(variantInput.value);
            }
        }
        const selectedRadio = document.querySelector('input[type="radio"][data-single-option-selector]:checked[data-variant-id]');
        if (selectedRadio && selectedRadio.dataset.variantId) {
            return String(selectedRadio.dataset.variantId);
        }
        if (button.dataset.variantId) {
            return String(button.dataset.variantId);
        }
        return null;
    }

    function getQuantity(button) {
        if (!button) {
            return 1;
        }
        if (button.dataset.quantity) {
            const qty = parseInt(button.dataset.quantity, 10);
            if (!isNaN(qty) && qty > 0) {
                return qty;
            }
        }
        const form = button.closest('form[action*="/cart/add"]');
        if (form) {
            const quantityInput = form.querySelector('[name="quantity"]');
            if (quantityInput && quantityInput.value) {
                const qty = parseInt(quantityInput.value, 10);
                if (!isNaN(qty) && qty > 0) {
                    return qty;
                }
            }
        }
        const variantId = getVariantId(button);
        if (variantId) {
            const variantElement = document.querySelector(`[data-variant-id="${variantId}"] .quantity-value,
           [data-variant-id="${variantId}"] .quantity__value,
           [data-variant-id="${variantId}"] .quantity-wrapper span,
           [data-variant-id="${variantId}"] .quantity-selector span,
           [data-variant-id="${variantId}"] .active-qty`);
            if (variantElement) {
                const qty = parseInt(variantElement.textContent.trim(), 10);
                if (!isNaN(qty) && qty > 0) {
                    return qty;
                }
            }
        }
        return 1;
    }
    async function getCart(forceRefresh = false) {
        if (!forceRefresh && cachedCart) {
            return cachedCart;
        }
        const response = await fetch('/cart.js', {
            method: 'GET',
            cache: 'no-store',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json'
            }
        });
        if (!response.ok) {
            throw new Error('Unable to fetch cart');
        }
        cachedCart = await response.json();
        return cachedCart;
    }

    function updateCachedCart(cart) {
        if (cart) {
            cachedCart = cart;
        }
        return cart;
    }
    async function clearCart(cart = null) {
        const currentCart = cart || cachedCart || await getCart();
        if (!currentCart.items || !currentCart.items.length) {
            return currentCart;
        }
        const response = await fetch('/cart/clear.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json'
            }
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error('Unable to clear cart: ' + errorText);
        }
        const updatedCart = await response.json();
        return updateCachedCart(updatedCart);
    }
    async function addProduct(variantId, quantity) {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: Number(variantId),
                    quantity: Number(quantity)
                }]
            })
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error('Unable to add product: ' + errorText);
        }
        const result = await response.json();
        cachedCart = null;
        return result;
    }

    function getEligibleCartTotal(cart) {
        if (!cart || !Array.isArray(cart.items)) {
            return 0;
        }
        return cart.items.reduce(function(total, item) {
            if (!item) {
                return total;
            }
            const properties = item.properties || {};
            const isFreebie = properties._freebie === true || properties._freebie === 'true' || properties.freebie === true || properties.freebie === 'true';
            const isFreeGift = item.product && Array.isArray(item.product.tags) && item.product.tags.includes('free-gift');
            if (isFreebie || isFreeGift) {
                return total;
            }
            const linePrice = Number(item.final_line_price);
            return (total + (isNaN(linePrice) ? 0 : linePrice));
        }, 0);
    }

    function isAutomaticFreebieEligible(cart) {
        return (getEligibleCartTotal(cart) / 100) >= AUTOMATIC_FREEBIE_THRESHOLD;
    }

    function getAutomaticFreebieVariantId() {
        const freebieElement = document.querySelector('.freebie-single-product');
        if (!freebieElement) {
            return null;
        }
        if (freebieElement.dataset.variantId) {
            return String(freebieElement.dataset.variantId);
        }
        const child = freebieElement.querySelector('[data-variant-id]');
        if (child && child.dataset.variantId) {
            return String(child.dataset.variantId);
        }
        const input = freebieElement.querySelector('input[name="id"], select[name="id"]');
        if (input && input.value) {
            return String(input.value);
        }
        return null;
    }

    function hasAutomaticFreebie(cart) {
        const freebieVariantId = getAutomaticFreebieVariantId();
        if (!freebieVariantId) {
            return false;
        }
        return (cart.items || []).some(item => String(item.variant_id) === String(freebieVariantId));
    }

//     function triggerExistingCartLogic(
//   variantId,
//   quantity
// ) {

//   const detail = {
//     variantId,
//     quantity
//   };

//   document.dispatchEvent(
//     new CustomEvent(
//       'theme:cart:refresh',
//       {
//         detail
//       }
//     )
//   );

//   document.dispatchEvent(
//     new CustomEvent(
//       'theme:cart:add',
//       {
//         detail
//       }
//     )
//   );

//   document.dispatchEvent(
//     new CustomEvent(
//       'theme:product:add',
//       {
//         detail
//       }
//     )
//   );
// }
    async function addAutomaticFreebieIfRequired(cart) {
        if (!isAutomaticFreebieEligible(cart)) {
            return cart;
        }
        if (hasAutomaticFreebie(cart)) {
            return cart;
        }
        const freebieVariantId = getAutomaticFreebieVariantId();
        if (!freebieVariantId) {
            console.warn('[Custom Buy Now] Freebie variant not found.');
            return cart;
        }
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: Number(freebieVariantId),
                    quantity: 1
                }]
            })
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error('Unable to add automatic freebie: ' + errorText);
        }
        await response.json();
        cachedCart = null;
        // triggerExistingCartLogic(
        //   freebieVariantId,
        //   1
        // );
        return getCart(true);
    }
    async function waitForAutomaticFreebie(variantId, quantity) {
        // triggerExistingCartLogic(
        //   variantId,
        //   quantity
        // );
        let cart = await getCart(true);
        if (!isAutomaticFreebieEligible(cart)) {
            return cart;
        }
        if (hasAutomaticFreebie(cart)) {
            return cart;
        }
        for (let i = 0; i < FREEBIE_CHECK_DELAYS.length; i++) {
            await sleep(FREEBIE_CHECK_DELAYS[i]);
            cart = await getCart(true);
            if (hasAutomaticFreebie(cart)) {
                return cart;
            }
            if (i === 1) {
                // triggerExistingCartLogic(variantId, quantity);
            }
        }
        return addAutomaticFreebieIfRequired(cart);
    }
    async function saveOriginalCart() {
        const currentCart = await getCart(true);
        const originalItems = Array.isArray(currentCart.items) ? currentCart.items.filter(item => item && item.variant_id && Number(item.quantity) > 0).map(item => ({
            id: Number(item.variant_id),
            quantity: Number(item.quantity)
        })) : [];
        const restoreUpdates = {};
        originalItems.forEach(item => {
            restoreUpdates[String(item.id)] = item.quantity;
        });
        originalBuyNowCart = {
            items: originalItems,
            restoreUpdates: restoreUpdates
        };
        buyNowCartRestored = false;
        isRestoringOriginalCart = false;
        cancellationRestoreRunning = false;
        restoreQueued = false;
        console.log('[Custom Buy Now] Original cart saved:', originalItems);
        return currentCart;
    }

    function prepareTemporaryCartRemoval(cart) {
        if (!originalBuyNowCart || !cart || !Array.isArray(cart.items)) {
            return;
        }
        const originalVariantIds = new Set(originalBuyNowCart.items.map(item => String(item.id)));
        cart.items.forEach(item => {
            if (!item || !item.variant_id) {
                return;
            }
            const variantId = String(item.variant_id);
            if (originalVariantIds.has(variantId)) {
                return;
            }
            if (item.key) {
                originalBuyNowCart.restoreUpdates[item.key] = 0;
            } else {
                originalBuyNowCart.restoreUpdates[variantId] = 0;
            }
        });
        originalBuyNowCart.items.forEach(item => {
            originalBuyNowCart.restoreUpdates[String(item.id)] = Number(item.quantity);
        });
        console.log('[Custom Buy Now] Restore payload:', originalBuyNowCart.restoreUpdates);
    }

    function closeCart() {
        const selectors = ['.drawer--cart'];
        selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(drawer => {
                drawer.classList.remove('is-open');
                // drawer.setAttribute('aria-hidden', 'true');
                if (drawer.style.display !== 'none') {}
            });
        });
        // document.body.classList.remove('drawer-open', 'cart-drawer-open', 'js-drawer-open', 'overflow-hidden');
    }

    function stopRestoreWatchdog() {
        if (restoreWatchdog) {
            clearInterval(restoreWatchdog);
            restoreWatchdog = null;
        }
    }
    async function restoreOriginalCartFast() {
        if (buyNowCartRestored) {
            return true;
        }
        if (isRestoringOriginalCart) {
            return false;
        }
        if (!originalBuyNowCart) {
            return false;
        }
        isRestoringOriginalCart = true;
        try {
            const updates = originalBuyNowCart.restoreUpdates;
            if (!updates || typeof updates !== 'object') {
                throw new Error('Restore payload is empty');
            }
            console.log('[Custom Buy Now] RESTORE START', performance.now());
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                keepalive: true,
                cache: 'no-store',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    updates
                })
            });
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error('Cart restore failed: ' + errorText);
            }
            const restoredCart = await response.json();
            cachedCart = restoredCart;
            buyNowCartRestored = true;
            buyNowCheckoutActive = false;
            checkoutReturnDetected = true;
            stopRestoreWatchdog();
            console.log('[Custom Buy Now] RESTORE COMPLETE', performance.now());
            // triggerExistingCartLogic();
            return true;
        } catch (error) {
            console.error('[Custom Buy Now] Restore failed:', error);
            cachedCart = null;
            restoreQueued = false;
            return false;
        } finally {
            isRestoringOriginalCart = false;
        }
    }
    async function restoreAfterBuyNowCancellation() {
        if (cancellationRestoreRunning) {
            return;
        }
        if (buyNowCartRestored) {
            return;
        }
        if (!buyNowCheckoutActive) {
            return;
        }
        if (!originalBuyNowCart) {
            return;
        }
        cancellationRestoreRunning = true;
        try {
            console.log('[Custom Buy Now] Checkout returned. Restoring cart.');
            const restored = await restoreOriginalCartFast();
            if (restored) {
                const button = activeBuyNowButton;
                resetBuyNowState(button);
                originalBuyNowCart = null;
            }
        } catch (error) {
            console.error('[Custom Buy Now] Restore controller error:', error);
        } finally {
            cancellationRestoreRunning = false;
            restoreQueued = false;
        }
    }

    function triggerInstantRestore() {
        if (!buyNowCheckoutActive) {
            return;
        }
        if (buyNowCartRestored) {
            return;
        }
        if (restoreQueued) {
            return;
        }
        restoreQueued = true;
        restoreAfterBuyNowCancellation();
    }

    function startRestoreWatchdog() {
        stopRestoreWatchdog();
        checkoutOpenedAt = performance.now();
        checkoutReturnDetected = false;
        lastDocumentVisibility = document.visibilityState;
        restoreWatchdog = setInterval(function() {
            if (buyNowCartRestored) {
                stopRestoreWatchdog();
                return;
            }
            if (!buyNowCheckoutActive) {
                stopRestoreWatchdog();
                return;
            }
            const currentVisibility = document.visibilityState;
            if (lastDocumentVisibility === 'hidden' && currentVisibility === 'visible') {
                console.log('[Custom Buy Now] Hidden → visible detected');
                triggerInstantRestore();
            }
            lastDocumentVisibility = currentVisibility;
            if (currentVisibility === 'visible') {
                const elapsed = performance.now() - checkoutOpenedAt;
                // if (
                //   elapsed > 300
                // ) {
                //   /*
                //    * If GoKwik is no longer blocking the
                //    * checkout flow, this will be picked up
                //    * here without user interaction.
                //    *
                //    * The guard prevents duplicate restore.
                //    */
                //   if (
                //     !checkoutReturnDetected &&
                //     !isRestoringOriginalCart
                //   ) {
                //     /*
                //      * Focus is not required.
                //      *
                //      * We use the fact that the Buy Now
                //      * operation is still active and the
                //      * checkout has been open for a while.
                //      *
                //      * The actual cart restore itself is
                //      * protected against duplicates.
                //      */
                //     if (
                //       document.visibilityState ===
                //       'visible'
                //     ) {
                //       /*
                //        * Only trigger when browser has
                //        * returned from an external checkout.
                //        *
                //        * For iframe/modal checkout, the
                //        * GoKwik close event below is preferred.
                //        */
                //     }
                //   }
                // }
            }
        }, RESTORE_WATCHDOG_INTERVAL);
    }
    window.addEventListener('pageshow', function() {
        if (buyNowCheckoutActive) {
            triggerInstantRestore();
        }
    }, {
        passive: true
    });
    window.addEventListener('focus', function() {
        if (buyNowCheckoutActive) {
            triggerInstantRestore();
        }
    }, {
        passive: true
    });
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            if (buyNowCheckoutActive) {
                triggerInstantRestore();
            }
        }
    }, {
        passive: true
    });

    function waitForGoKwikSDK() {
        if (sdkPromise) {
            return sdkPromise;
        }
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function') {
            sdkPromise = Promise.resolve(window.gokwikSdk);
            return sdkPromise;
        }
        if (window.__gkSdkCache && typeof window.__gkSdkCache.initCheckout === 'function') {
            sdkPromise = Promise.resolve(window.__gkSdkCache);
            return sdkPromise;
        }
        sdkPromise = new Promise(resolve => {
            let attempts = 0;

            function check() {
                const sdk = window.gokwikSdk || window.__gkSdkCache;
                if (sdk && typeof sdk.initCheckout === 'function') {
                    resolve(sdk);
                    return;
                }
                attempts++;
                if (attempts >= 50) {
                    resolve(null);
                    return;
                }
                setTimeout(check, 50);
            }
            check();
        });
        return sdkPromise;
    }

    function setButtonLoading(button) {
        if (!button) {
            return;
        }
        if (!button.dataset.originalHtml) {
            button.dataset.originalHtml = button.innerHTML;
        }
        button.disabled = true;
        button.classList.add('loading', 'is-loading');
        button.dataset.customBuyNowProcessing = 'true';
        const textElement = button.querySelector('.btn__text');
        if (textElement) {
            textElement.textContent = 'Processing...';
        } else {
            button.innerHTML = 'Processing...';
        }
        showOverlay();
    }

    function resetButton(button) {
        if (!button) {
            return;
        }
        button.disabled = false;
        button.classList.remove('loading', 'is-loading');
        if (button.dataset.originalHtml) {
            button.innerHTML = button.dataset.originalHtml;
        }
        delete button.dataset.originalHtml;
        delete button.dataset.customBuyNowProcessing;
    }

    function resetBuyNowState(button) {
        stopRestoreWatchdog();
        stopGoKwikOverlayObserver();
        if (button) {
            resetButton(button);
        }
        hideOverlay();
        activeBuyNowButton = null;
        buyNowRunning = false;
    }
    async function handleBuyNow(button) {
        if (!button) {
            return;
        }
        if (buyNowRunning) {
            console.log('[Custom Buy Now] Buy Now already running.');
            return;
        }
        closeCart();
        const clickedButton = button;
        const variantId = getVariantId(clickedButton);
        const quantity = getQuantity(clickedButton);
        if (!variantId) {
            console.error('[Custom Buy Now] Variant ID not found.');
            return;
        }
        buyNowRunning = true;
        activeBuyNowButton = clickedButton;
        buyNowCheckoutActive = false;
        buyNowCartRestored = false;
        isRestoringOriginalCart = false;
        cancellationRestoreRunning = false;
        restoreQueued = false;
        checkoutReturnDetected = false;
        originalBuyNowCart = null;
        cachedCart = null;
        setButtonLoading(clickedButton);
        const sdkPromise = waitForGoKwikSDK();
        try {
            const savedCart = await saveOriginalCart();
            cachedCart = savedCart;
            await clearCart(savedCart);
            await addProduct(variantId, quantity);
            closeCart();
            let checkoutCart = await waitForAutomaticFreebie(variantId, quantity);
            if (!checkoutCart) {
                checkoutCart = await getCart(true);
            }
            prepareTemporaryCartRemoval(checkoutCart);
            const eligible = isAutomaticFreebieEligible(checkoutCart);
            const freebiePresent = hasAutomaticFreebie(checkoutCart);
            console.log('[Custom Buy Now] FINAL CHECK', {
                eligible,
                eligibleValue: getEligibleCartTotal(checkoutCart) / 100,
                freebiePresent,
                items: checkoutCart.items
            });
            if (eligible && !freebiePresent) {
                throw new Error('Eligible Buy Now cart does not contain the automatic freebie.');
            }
            const sdk = await sdkPromise;
            if (!sdk) {
                throw new Error('GoKwik SDK not available.');
            }
            if (typeof sdk.initCheckout !== 'function') {
                throw new Error('GoKwik initCheckout unavailable.');
            }
            closeCart();
            buyNowCheckoutActive = true;
            checkoutReturnDetected = false;
            console.log('[Custom Buy Now] Opening GoKwik...');
            startRestoreWatchdog();
            startGoKwikOverlayObserver();
            await sdk.initCheckout(window.merchantInfo);
        } catch (error) {
            console.error('[Custom Buy Now] Error:', error);
            if (!buyNowCheckoutActive) {
                try {
                    const restored = await restoreOriginalCartFast();
                    if (restored) {
                        originalBuyNowCart = null;
                    }
                } catch (restoreError) {
                    console.error('[Custom Buy Now] Restore failed:', restoreError);
                }
                resetBuyNowState(clickedButton);
            }
        }
    }
    document.addEventListener('click', function(event) {
        const button = event.target.closest(BUY_NOW_SELECTOR);
        if (!button) {
            return;
        }
        if (button.dataset.customBuyNowProcessing === 'true') {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        button.dataset.gokwikProcessed = 'true';
        handleBuyNow(button);
    }, true);

    function protectBuyNowButtons(root = document) {
        if (root && root.matches && root.matches(BUY_NOW_SELECTOR)) {
            root.dataset.gokwikProcessed = 'true';
        }
        if (root && root.querySelectorAll) {
            root.querySelectorAll(BUY_NOW_SELECTOR).forEach(button => {
                button.dataset.gokwikProcessed = 'true';
            });
        }
    }
    protectBuyNowButtons();
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) {
                    return;
                }
                protectBuyNowButtons(node);
            });
        });
    });
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
})();